"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Portal API
 * Portal API
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationsApiAxiosParamCreator = exports.ApplicationAnalyticsApi = exports.ApplicationAnalyticsApiFactory = exports.ApplicationAnalyticsApiFp = exports.ApplicationAnalyticsApiAxiosParamCreator = exports.TextBlockTypeEnum = exports.TextTypeEnum = exports.TaskCheckboxTypeEnum = exports.TableRowBlockTypeEnum = exports.TableHeaderBlockTypeEnum = exports.TableCellBlockTypeEnum = exports.TableBlockTypeEnum = exports.StrikeThroughTypeEnum = exports.StatusCodeGroupedFilterDimensionEnum = exports.StatusCodeFilterDimensionEnum = exports.SearchIndicesParameters = exports.QueryResponseMetaMetricNamesEnum = exports.QueryApplicationAnalyticsDimensionsEnum = exports.QueryApplicationAnalyticsMetricsEnum = exports.ProductVersionApplicationRegistrationStatusEnum = exports.PortalAuthStrategyKeyAuthCredentialTypeEnum = exports.PortalAuthStrategyClientCredentialsCredentialTypeEnum = exports.ParagraphBlockTypeEnum = exports.ListItemBlockTypeEnum = exports.ListBlockTypeEnum = exports.LinkTypeEnum = exports.InvalidRules = exports.InvalidParameterMinimumLengthRuleEnum = exports.InvalidParameterMaximumLengthRuleEnum = exports.InvalidParameterDependentItemRuleEnum = exports.InvalidParameterChoiceItemRuleEnum = exports.ImageTypeEnum = exports.HeadingBlockTypeEnum = exports.GetRegistrationResponseStatusEnum = exports.FilterType = exports.EmphasisTypeEnum = exports.DocumentFormatContentTypeEnum = exports.DocumentContentTypeEnum = exports.DocumentBlockTypeEnum = exports.CredentialType = exports.CodeBlockTypeEnum = exports.CodeTypeEnum = exports.BreakBlockTypeEnum = exports.BlockQuoteBlockTypeEnum = exports.AuthStrategyKeyAuthCredentialTypeEnum = exports.AuthStrategyClientCredentialsCredentialTypeEnum = exports.ApplicationFilterDimensionEnum = exports.ApiTypeEnum = exports.ApiProductVersionFilterDimensionEnum = exports.AlignmentKind = void 0;
exports.VersionsApi = exports.VersionsApiFactory = exports.VersionsApiFp = exports.VersionsApiAxiosParamCreator = exports.SearchApi = exports.SearchApiFactory = exports.SearchApiFp = exports.SearchApiAxiosParamCreator = exports.RegistrationsApi = exports.RegistrationsApiFactory = exports.RegistrationsApiFp = exports.RegistrationsApiAxiosParamCreator = exports.ProductsApi = exports.ProductsApiFactory = exports.ProductsApiFp = exports.ProductsApiAxiosParamCreator = exports.PortalApi = exports.PortalApiFactory = exports.PortalApiFp = exports.PortalApiAxiosParamCreator = exports.DocumentationApi = exports.DocumentationApiFactory = exports.DocumentationApiFp = exports.DocumentationApiAxiosParamCreator = exports.DeveloperApi = exports.DeveloperApiFactory = exports.DeveloperApiFp = exports.DeveloperApiAxiosParamCreator = exports.CredentialsApi = exports.CredentialsApiFactory = exports.CredentialsApiFp = exports.CredentialsApiAxiosParamCreator = exports.ApplicationsApi = exports.ApplicationsApiFactory = exports.ApplicationsApiFp = void 0;
var axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.AlignmentKind = {
    Left: 'left',
    Right: 'right',
    Center: 'center',
    None: 'none'
};
exports.ApiProductVersionFilterDimensionEnum = {
    ApiProductVersion: 'API_PRODUCT_VERSION'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ApiTypeEnum = {
    Openapi: 'openapi'
};
exports.ApplicationFilterDimensionEnum = {
    Application: 'APPLICATION'
};
exports.AuthStrategyClientCredentialsCredentialTypeEnum = {
    ClientCredentials: 'client_credentials',
    SelfManagedClientCredentials: 'self_managed_client_credentials'
};
exports.AuthStrategyKeyAuthCredentialTypeEnum = {
    KeyAuth: 'key_auth'
};
exports.BlockQuoteBlockTypeEnum = {
    Blockquote: 'blockquote'
};
exports.BreakBlockTypeEnum = {
    Break: 'break'
};
exports.CodeTypeEnum = {
    Code: 'code'
};
exports.CodeBlockTypeEnum = {
    CodeBlock: 'code_block'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CredentialType = {
    ClientCredentials: 'client_credentials',
    SelfManagedClientCredentials: 'self_managed_client_credentials',
    KeyAuth: 'key_auth'
};
exports.DocumentBlockTypeEnum = {
    Document: 'document'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.DocumentContentTypeEnum = {
    Json: 'application/json',
    VndKonnectDocumentTreejson: 'application/vnd.konnect.document-tree+json'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.DocumentFormatContentTypeEnum = {
    TextMarkdown: 'text/markdown',
    ApplicationJson: 'application/json',
    ApplicationVndKonnectDocumentNodesjson: 'application/vnd.konnect.document-nodes+json'
};
exports.EmphasisTypeEnum = {
    Emphasis: 'emphasis'
};
/**
 * The type of filter to apply.  `IN` filters will limit results to only the specified values, while `NOT_IN` filters will exclude the specified values.
 * @export
 * @enum {string}
 */
exports.FilterType = {
    In: 'IN',
    NotIn: 'NOT_IN'
};
exports.GetRegistrationResponseStatusEnum = {
    Approved: 'approved',
    Pending: 'pending',
    Rejected: 'rejected',
    Revoked: 'revoked'
};
exports.HeadingBlockTypeEnum = {
    Heading: 'heading'
};
exports.ImageTypeEnum = {
    Image: 'image'
};
exports.InvalidParameterChoiceItemRuleEnum = {
    Enum: 'enum'
};
exports.InvalidParameterDependentItemRuleEnum = {
    DependentFields: 'dependent_fields'
};
exports.InvalidParameterMaximumLengthRuleEnum = {
    MaxLength: 'max_length',
    MaxItems: 'max_items',
    Max: 'max'
};
exports.InvalidParameterMinimumLengthRuleEnum = {
    MinLength: 'min_length',
    MinDigits: 'min_digits',
    MinLowercase: 'min_lowercase',
    MinUppercase: 'min_uppercase',
    MinSymbols: 'min_symbols',
    MinItems: 'min_items',
    Min: 'min'
};
/**
 * invalid parameters rules
 * @export
 * @enum {string}
 */
exports.InvalidRules = {
    Required: 'required',
    IsArray: 'is_array',
    IsBase64: 'is_base64',
    IsBoolean: 'is_boolean',
    IsDateTime: 'is_date_time',
    IsInteger: 'is_integer',
    IsNull: 'is_null',
    IsNumber: 'is_number',
    IsObject: 'is_object',
    IsString: 'is_string',
    IsUuid: 'is_uuid',
    IsFqdn: 'is_fqdn',
    IsArn: 'is_arn',
    UnknownProperty: 'unknown_property',
    IsLabel: 'is_label',
    MatchesRegex: 'matches_regex',
    Invalid: 'invalid',
    IsSupportedNetworkAvailabilityZoneList: 'is_supported_network_availability_zone_list',
    IsSupportedNetworkCidrBlock: 'is_supported_network_cidr_block',
    IsSupportedProviderRegion: 'is_supported_provider_region'
};
exports.LinkTypeEnum = {
    Link: 'link'
};
exports.ListBlockTypeEnum = {
    List: 'list'
};
exports.ListItemBlockTypeEnum = {
    ListItem: 'list_item'
};
exports.ParagraphBlockTypeEnum = {
    Paragraph: 'paragraph'
};
exports.PortalAuthStrategyClientCredentialsCredentialTypeEnum = {
    ClientCredentials: 'client_credentials',
    SelfManagedClientCredentials: 'self_managed_client_credentials'
};
exports.PortalAuthStrategyKeyAuthCredentialTypeEnum = {
    KeyAuth: 'key_auth'
};
exports.ProductVersionApplicationRegistrationStatusEnum = {
    Approved: 'approved',
    Pending: 'pending',
    Rejected: 'rejected',
    Revoked: 'revoked'
};
exports.QueryApplicationAnalyticsMetricsEnum = {
    RequestCount: 'REQUEST_COUNT',
    RequestPerMinute: 'REQUEST_PER_MINUTE',
    ResponseLatencyP99: 'RESPONSE_LATENCY_P99',
    ResponseLatencyP95: 'RESPONSE_LATENCY_P95',
    ResponseLatencyP50: 'RESPONSE_LATENCY_P50',
    ResponseSizeP99: 'RESPONSE_SIZE_P99',
    ResponseSizeP95: 'RESPONSE_SIZE_P95',
    ResponseSizeP50: 'RESPONSE_SIZE_P50',
    RequestSizeP99: 'REQUEST_SIZE_P99',
    RequestSizeP95: 'REQUEST_SIZE_P95',
    RequestSizeP50: 'REQUEST_SIZE_P50'
};
exports.QueryApplicationAnalyticsDimensionsEnum = {
    ApiProductVersion: 'API_PRODUCT_VERSION',
    Application: 'APPLICATION',
    StatusCode: 'STATUS_CODE',
    StatusCodeGrouped: 'STATUS_CODE_GROUPED',
    Time: 'TIME'
};
exports.QueryResponseMetaMetricNamesEnum = {
    RequestCount: 'REQUEST_COUNT',
    RequestPerMinute: 'REQUEST_PER_MINUTE',
    ResponseLatencyP99: 'RESPONSE_LATENCY_P99',
    ResponseLatencyP95: 'RESPONSE_LATENCY_P95',
    ResponseLatencyP50: 'RESPONSE_LATENCY_P50',
    ResponseSizeP99: 'RESPONSE_SIZE_P99',
    ResponseSizeP95: 'RESPONSE_SIZE_P95',
    ResponseSizeP50: 'RESPONSE_SIZE_P50',
    RequestSizeP99: 'REQUEST_SIZE_P99',
    RequestSizeP95: 'REQUEST_SIZE_P95',
    RequestSizeP50: 'REQUEST_SIZE_P50'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.SearchIndicesParameters = {
    ProductCatalog: 'product-catalog'
};
exports.StatusCodeFilterDimensionEnum = {
    StatusCode: 'STATUS_CODE'
};
exports.StatusCodeGroupedFilterDimensionEnum = {
    StatusCodeGrouped: 'STATUS_CODE_GROUPED'
};
exports.StrikeThroughTypeEnum = {
    Strikethrough: 'strikethrough'
};
exports.TableBlockTypeEnum = {
    Table: 'table'
};
exports.TableCellBlockTypeEnum = {
    TableCell: 'table_cell'
};
exports.TableHeaderBlockTypeEnum = {
    TableHeader: 'table_header'
};
exports.TableRowBlockTypeEnum = {
    TableRow: 'table_row'
};
exports.TaskCheckboxTypeEnum = {
    TaskCheckbox: 'task_checkbox'
};
exports.TextTypeEnum = {
    Text: 'text'
};
exports.TextBlockTypeEnum = {
    TextBlock: 'text_block'
};
/**
 * ApplicationAnalyticsApi - axios parameter creator
 * @export
 */
var ApplicationAnalyticsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get config for application analytics
         * @summary Application Analytics Config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationAnalyticsConfig: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v2/stats/config";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication portalAccessToken required
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Query
         * @summary Query Application Analytics
         * @param {QueryApplicationAnalytics} [queryApplicationAnalytics] Object describing the query sent to analytics API.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryApplicationAnalytics: function (queryApplicationAnalytics, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v2/stats";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication portalAccessToken required
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(queryApplicationAnalytics, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.ApplicationAnalyticsApiAxiosParamCreator = ApplicationAnalyticsApiAxiosParamCreator;
/**
 * ApplicationAnalyticsApi - functional programming interface
 * @export
 */
var ApplicationAnalyticsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ApplicationAnalyticsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get config for application analytics
         * @summary Application Analytics Config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationAnalyticsConfig: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getApplicationAnalyticsConfig(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Query
         * @summary Query Application Analytics
         * @param {QueryApplicationAnalytics} [queryApplicationAnalytics] Object describing the query sent to analytics API.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryApplicationAnalytics: function (queryApplicationAnalytics, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.queryApplicationAnalytics(queryApplicationAnalytics, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ApplicationAnalyticsApiFp = ApplicationAnalyticsApiFp;
/**
 * ApplicationAnalyticsApi - factory interface
 * @export
 */
var ApplicationAnalyticsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ApplicationAnalyticsApiFp)(configuration);
    return {
        /**
         * Get config for application analytics
         * @summary Application Analytics Config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationAnalyticsConfig: function (options) {
            return localVarFp.getApplicationAnalyticsConfig(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Query
         * @summary Query Application Analytics
         * @param {QueryApplicationAnalytics} [queryApplicationAnalytics] Object describing the query sent to analytics API.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryApplicationAnalytics: function (queryApplicationAnalytics, options) {
            return localVarFp.queryApplicationAnalytics(queryApplicationAnalytics, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ApplicationAnalyticsApiFactory = ApplicationAnalyticsApiFactory;
/**
 * ApplicationAnalyticsApi - object-oriented interface
 * @export
 * @class ApplicationAnalyticsApi
 * @extends {BaseAPI}
 */
var ApplicationAnalyticsApi = /** @class */ (function (_super) {
    __extends(ApplicationAnalyticsApi, _super);
    function ApplicationAnalyticsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get config for application analytics
     * @summary Application Analytics Config
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationAnalyticsApi
     */
    ApplicationAnalyticsApi.prototype.getApplicationAnalyticsConfig = function (options) {
        var _this = this;
        return (0, exports.ApplicationAnalyticsApiFp)(this.configuration).getApplicationAnalyticsConfig(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Query
     * @summary Query Application Analytics
     * @param {ApplicationAnalyticsApiQueryApplicationAnalyticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationAnalyticsApi
     */
    ApplicationAnalyticsApi.prototype.queryApplicationAnalytics = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApplicationAnalyticsApiFp)(this.configuration).queryApplicationAnalytics(requestParameters.queryApplicationAnalytics, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ApplicationAnalyticsApi;
}(base_1.BaseAPI));
exports.ApplicationAnalyticsApi = ApplicationAnalyticsApi;
/**
 * ApplicationsApi - axios parameter creator
 * @export
 */
var ApplicationsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Creates a new Application.
         * @summary Create an Application
         * @param {CreateApplicationPayload} createApplicationPayload Create an application
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApplication: function (createApplicationPayload, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'createApplicationPayload' is not null or undefined
                    (0, common_1.assertParamExists)('createApplication', 'createApplicationPayload', createApplicationPayload);
                    localVarPath = "/api/v2/applications";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication portalAccessToken required
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createApplicationPayload, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Deletes an application and all of its associated entities (registrations).
         * @summary Delete Application
         * @param {string} applicationId Id of the targeted application
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApplication: function (applicationId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'applicationId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteApplication', 'applicationId', applicationId);
                    localVarPath = "/api/v2/applications/{applicationId}"
                        .replace("{".concat("applicationId", "}"), encodeURIComponent(String(applicationId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication portalAccessToken required
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Gets the details for an existing application. You need only supply the unique application identifier that was returned upon application creation or by the list-applications endpoint.
         * @summary Get an Application
         * @param {string} applicationId Id of the targeted application
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplication: function (applicationId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'applicationId' is not null or undefined
                    (0, common_1.assertParamExists)('getApplication', 'applicationId', applicationId);
                    localVarPath = "/api/v2/applications/{applicationId}"
                        .replace("{".concat("applicationId", "}"), encodeURIComponent(String(applicationId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication portalAccessToken required
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Retrieves the granted scopes of a specified application and product version directly from the IDP. Scopes shared between product versions will be returned, even if not currently registered for given product version. Will return 422 if this feature is not supported by the application.
         * @summary Get the granted scopes
         * @param {string} applicationId Id of the targeted application
         * @param {string} productVersionId Contains a unique identifier used by the Portal API for this resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationProductVersionGrantedScopes: function (applicationId, productVersionId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'applicationId' is not null or undefined
                    (0, common_1.assertParamExists)('getApplicationProductVersionGrantedScopes', 'applicationId', applicationId);
                    // verify required parameter 'productVersionId' is not null or undefined
                    (0, common_1.assertParamExists)('getApplicationProductVersionGrantedScopes', 'productVersionId', productVersionId);
                    localVarPath = "/api/v2/applications/{applicationId}/product-versions/{productVersionId}/granted-scopes"
                        .replace("{".concat("applicationId", "}"), encodeURIComponent(String(applicationId)))
                        .replace("{".concat("productVersionId", "}"), encodeURIComponent(String(productVersionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication portalAccessToken required
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Retrieve the available Auth Strategies on this portal. An Auth Strategy is a set of plugin configurations that represent how the gateway will perform authentication and authorization for a Product Version. It may reference to Key-Auth or an OIDC configuration (with or without DCR).
         * @summary List the available auth strategies
         * @param {number} [pageSize] The maximum number of items to include per page. The last page of a collection may include fewer items.
         * @param {number} [pageNumber] Determines which page of the entities to retrieve.
         * @param {string} [filterNameEq] Filter by direct equality comparison of the name property with a supplied value.
         * @param {string} [filterName] Filter by direct equality comparison (short-hand) of the name property with a supplied value.
         * @param {string} [filterNameContains] Filter by contains comparison of the name property with a supplied substring
         * @param {'client_credentials' | 'self_managed_client_credentials' | 'key_auth'} [filterCredentialTypeEq] Filter by direct equality comparison of the credential_type with a supplied value.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApplicationAuthStrategies: function (pageSize, pageNumber, filterNameEq, filterName, filterNameContains, filterCredentialTypeEq, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v2/applications/auth-strategies";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication portalAccessToken required
                    if (pageSize !== undefined) {
                        localVarQueryParameter['page[size]'] = pageSize;
                    }
                    if (pageNumber !== undefined) {
                        localVarQueryParameter['page[number]'] = pageNumber;
                    }
                    if (filterNameEq !== undefined) {
                        localVarQueryParameter['filter[name][eq]'] = filterNameEq;
                    }
                    if (filterName !== undefined) {
                        localVarQueryParameter['filter[name]'] = filterName;
                    }
                    if (filterNameContains !== undefined) {
                        localVarQueryParameter['filter[name][contains]'] = filterNameContains;
                    }
                    if (filterCredentialTypeEq !== undefined) {
                        localVarQueryParameter['filter[credential_type][eq]'] = filterCredentialTypeEq;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * List applications owned by the developer currently logged in.
         * @summary List Applications
         * @param {number} [pageSize] The maximum number of items to include per page. The last page of a collection may include fewer items.
         * @param {number} [pageNumber] Determines which page of the entities to retrieve.
         * @param {string} [filterNameEq] Filter by direct equality comparison of the name property with a supplied value.
         * @param {string} [filterName] Filter by direct equality comparison (short-hand) of the name property with a supplied value.
         * @param {string} [filterNameContains] Filter by contains comparison of the name property with a supplied substring
         * @param {string} [filterAuthStrategyIdEq] Filter by the id of the auth strategy supported by the application.
         * @param {string} [filterAuthStrategyId] Filter by the id of the auth strategy supported by the application (short-hand).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApplications: function (pageSize, pageNumber, filterNameEq, filterName, filterNameContains, filterAuthStrategyIdEq, filterAuthStrategyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v2/applications";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication portalAccessToken required
                    if (pageSize !== undefined) {
                        localVarQueryParameter['page[size]'] = pageSize;
                    }
                    if (pageNumber !== undefined) {
                        localVarQueryParameter['page[number]'] = pageNumber;
                    }
                    if (filterNameEq !== undefined) {
                        localVarQueryParameter['filter[name][eq]'] = filterNameEq;
                    }
                    if (filterName !== undefined) {
                        localVarQueryParameter['filter[name]'] = filterName;
                    }
                    if (filterNameContains !== undefined) {
                        localVarQueryParameter['filter[name][contains]'] = filterNameContains;
                    }
                    if (filterAuthStrategyIdEq !== undefined) {
                        localVarQueryParameter['filter[auth_strategy_id][eq]'] = filterAuthStrategyIdEq;
                    }
                    if (filterAuthStrategyId !== undefined) {
                        localVarQueryParameter['filter[auth_strategy_id]'] = filterAuthStrategyId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Updates an application, replacing specified properties with any new values supplied in the request body.
         * @summary Update Application
         * @param {string} applicationId Id of the targeted application
         * @param {UpdateApplicationPayload} updateApplicationPayload Update an application
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApplication: function (applicationId, updateApplicationPayload, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'applicationId' is not null or undefined
                    (0, common_1.assertParamExists)('updateApplication', 'applicationId', applicationId);
                    // verify required parameter 'updateApplicationPayload' is not null or undefined
                    (0, common_1.assertParamExists)('updateApplication', 'updateApplicationPayload', updateApplicationPayload);
                    localVarPath = "/api/v2/applications/{applicationId}"
                        .replace("{".concat("applicationId", "}"), encodeURIComponent(String(applicationId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication portalAccessToken required
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateApplicationPayload, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.ApplicationsApiAxiosParamCreator = ApplicationsApiAxiosParamCreator;
/**
 * ApplicationsApi - functional programming interface
 * @export
 */
var ApplicationsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ApplicationsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Creates a new Application.
         * @summary Create an Application
         * @param {CreateApplicationPayload} createApplicationPayload Create an application
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApplication: function (createApplicationPayload, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createApplication(createApplicationPayload, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Deletes an application and all of its associated entities (registrations).
         * @summary Delete Application
         * @param {string} applicationId Id of the targeted application
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApplication: function (applicationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteApplication(applicationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Gets the details for an existing application. You need only supply the unique application identifier that was returned upon application creation or by the list-applications endpoint.
         * @summary Get an Application
         * @param {string} applicationId Id of the targeted application
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplication: function (applicationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getApplication(applicationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieves the granted scopes of a specified application and product version directly from the IDP. Scopes shared between product versions will be returned, even if not currently registered for given product version. Will return 422 if this feature is not supported by the application.
         * @summary Get the granted scopes
         * @param {string} applicationId Id of the targeted application
         * @param {string} productVersionId Contains a unique identifier used by the Portal API for this resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationProductVersionGrantedScopes: function (applicationId, productVersionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getApplicationProductVersionGrantedScopes(applicationId, productVersionId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieve the available Auth Strategies on this portal. An Auth Strategy is a set of plugin configurations that represent how the gateway will perform authentication and authorization for a Product Version. It may reference to Key-Auth or an OIDC configuration (with or without DCR).
         * @summary List the available auth strategies
         * @param {number} [pageSize] The maximum number of items to include per page. The last page of a collection may include fewer items.
         * @param {number} [pageNumber] Determines which page of the entities to retrieve.
         * @param {string} [filterNameEq] Filter by direct equality comparison of the name property with a supplied value.
         * @param {string} [filterName] Filter by direct equality comparison (short-hand) of the name property with a supplied value.
         * @param {string} [filterNameContains] Filter by contains comparison of the name property with a supplied substring
         * @param {'client_credentials' | 'self_managed_client_credentials' | 'key_auth'} [filterCredentialTypeEq] Filter by direct equality comparison of the credential_type with a supplied value.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApplicationAuthStrategies: function (pageSize, pageNumber, filterNameEq, filterName, filterNameContains, filterCredentialTypeEq, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listApplicationAuthStrategies(pageSize, pageNumber, filterNameEq, filterName, filterNameContains, filterCredentialTypeEq, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * List applications owned by the developer currently logged in.
         * @summary List Applications
         * @param {number} [pageSize] The maximum number of items to include per page. The last page of a collection may include fewer items.
         * @param {number} [pageNumber] Determines which page of the entities to retrieve.
         * @param {string} [filterNameEq] Filter by direct equality comparison of the name property with a supplied value.
         * @param {string} [filterName] Filter by direct equality comparison (short-hand) of the name property with a supplied value.
         * @param {string} [filterNameContains] Filter by contains comparison of the name property with a supplied substring
         * @param {string} [filterAuthStrategyIdEq] Filter by the id of the auth strategy supported by the application.
         * @param {string} [filterAuthStrategyId] Filter by the id of the auth strategy supported by the application (short-hand).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApplications: function (pageSize, pageNumber, filterNameEq, filterName, filterNameContains, filterAuthStrategyIdEq, filterAuthStrategyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listApplications(pageSize, pageNumber, filterNameEq, filterName, filterNameContains, filterAuthStrategyIdEq, filterAuthStrategyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Updates an application, replacing specified properties with any new values supplied in the request body.
         * @summary Update Application
         * @param {string} applicationId Id of the targeted application
         * @param {UpdateApplicationPayload} updateApplicationPayload Update an application
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApplication: function (applicationId, updateApplicationPayload, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateApplication(applicationId, updateApplicationPayload, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ApplicationsApiFp = ApplicationsApiFp;
/**
 * ApplicationsApi - factory interface
 * @export
 */
var ApplicationsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ApplicationsApiFp)(configuration);
    return {
        /**
         * Creates a new Application.
         * @summary Create an Application
         * @param {CreateApplicationPayload} createApplicationPayload Create an application
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApplication: function (createApplicationPayload, options) {
            return localVarFp.createApplication(createApplicationPayload, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Deletes an application and all of its associated entities (registrations).
         * @summary Delete Application
         * @param {string} applicationId Id of the targeted application
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApplication: function (applicationId, options) {
            return localVarFp.deleteApplication(applicationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Gets the details for an existing application. You need only supply the unique application identifier that was returned upon application creation or by the list-applications endpoint.
         * @summary Get an Application
         * @param {string} applicationId Id of the targeted application
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplication: function (applicationId, options) {
            return localVarFp.getApplication(applicationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieves the granted scopes of a specified application and product version directly from the IDP. Scopes shared between product versions will be returned, even if not currently registered for given product version. Will return 422 if this feature is not supported by the application.
         * @summary Get the granted scopes
         * @param {string} applicationId Id of the targeted application
         * @param {string} productVersionId Contains a unique identifier used by the Portal API for this resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationProductVersionGrantedScopes: function (applicationId, productVersionId, options) {
            return localVarFp.getApplicationProductVersionGrantedScopes(applicationId, productVersionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieve the available Auth Strategies on this portal. An Auth Strategy is a set of plugin configurations that represent how the gateway will perform authentication and authorization for a Product Version. It may reference to Key-Auth or an OIDC configuration (with or without DCR).
         * @summary List the available auth strategies
         * @param {number} [pageSize] The maximum number of items to include per page. The last page of a collection may include fewer items.
         * @param {number} [pageNumber] Determines which page of the entities to retrieve.
         * @param {string} [filterNameEq] Filter by direct equality comparison of the name property with a supplied value.
         * @param {string} [filterName] Filter by direct equality comparison (short-hand) of the name property with a supplied value.
         * @param {string} [filterNameContains] Filter by contains comparison of the name property with a supplied substring
         * @param {'client_credentials' | 'self_managed_client_credentials' | 'key_auth'} [filterCredentialTypeEq] Filter by direct equality comparison of the credential_type with a supplied value.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApplicationAuthStrategies: function (pageSize, pageNumber, filterNameEq, filterName, filterNameContains, filterCredentialTypeEq, options) {
            return localVarFp.listApplicationAuthStrategies(pageSize, pageNumber, filterNameEq, filterName, filterNameContains, filterCredentialTypeEq, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * List applications owned by the developer currently logged in.
         * @summary List Applications
         * @param {number} [pageSize] The maximum number of items to include per page. The last page of a collection may include fewer items.
         * @param {number} [pageNumber] Determines which page of the entities to retrieve.
         * @param {string} [filterNameEq] Filter by direct equality comparison of the name property with a supplied value.
         * @param {string} [filterName] Filter by direct equality comparison (short-hand) of the name property with a supplied value.
         * @param {string} [filterNameContains] Filter by contains comparison of the name property with a supplied substring
         * @param {string} [filterAuthStrategyIdEq] Filter by the id of the auth strategy supported by the application.
         * @param {string} [filterAuthStrategyId] Filter by the id of the auth strategy supported by the application (short-hand).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApplications: function (pageSize, pageNumber, filterNameEq, filterName, filterNameContains, filterAuthStrategyIdEq, filterAuthStrategyId, options) {
            return localVarFp.listApplications(pageSize, pageNumber, filterNameEq, filterName, filterNameContains, filterAuthStrategyIdEq, filterAuthStrategyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates an application, replacing specified properties with any new values supplied in the request body.
         * @summary Update Application
         * @param {string} applicationId Id of the targeted application
         * @param {UpdateApplicationPayload} updateApplicationPayload Update an application
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApplication: function (applicationId, updateApplicationPayload, options) {
            return localVarFp.updateApplication(applicationId, updateApplicationPayload, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ApplicationsApiFactory = ApplicationsApiFactory;
/**
 * ApplicationsApi - object-oriented interface
 * @export
 * @class ApplicationsApi
 * @extends {BaseAPI}
 */
var ApplicationsApi = /** @class */ (function (_super) {
    __extends(ApplicationsApi, _super);
    function ApplicationsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Creates a new Application.
     * @summary Create an Application
     * @param {ApplicationsApiCreateApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsApi
     */
    ApplicationsApi.prototype.createApplication = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApplicationsApiFp)(this.configuration).createApplication(requestParameters.createApplicationPayload, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Deletes an application and all of its associated entities (registrations).
     * @summary Delete Application
     * @param {ApplicationsApiDeleteApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsApi
     */
    ApplicationsApi.prototype.deleteApplication = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApplicationsApiFp)(this.configuration).deleteApplication(requestParameters.applicationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Gets the details for an existing application. You need only supply the unique application identifier that was returned upon application creation or by the list-applications endpoint.
     * @summary Get an Application
     * @param {ApplicationsApiGetApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsApi
     */
    ApplicationsApi.prototype.getApplication = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApplicationsApiFp)(this.configuration).getApplication(requestParameters.applicationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieves the granted scopes of a specified application and product version directly from the IDP. Scopes shared between product versions will be returned, even if not currently registered for given product version. Will return 422 if this feature is not supported by the application.
     * @summary Get the granted scopes
     * @param {ApplicationsApiGetApplicationProductVersionGrantedScopesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsApi
     */
    ApplicationsApi.prototype.getApplicationProductVersionGrantedScopes = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApplicationsApiFp)(this.configuration).getApplicationProductVersionGrantedScopes(requestParameters.applicationId, requestParameters.productVersionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieve the available Auth Strategies on this portal. An Auth Strategy is a set of plugin configurations that represent how the gateway will perform authentication and authorization for a Product Version. It may reference to Key-Auth or an OIDC configuration (with or without DCR).
     * @summary List the available auth strategies
     * @param {ApplicationsApiListApplicationAuthStrategiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsApi
     */
    ApplicationsApi.prototype.listApplicationAuthStrategies = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApplicationsApiFp)(this.configuration).listApplicationAuthStrategies(requestParameters.pageSize, requestParameters.pageNumber, requestParameters.filterNameEq, requestParameters.filterName, requestParameters.filterNameContains, requestParameters.filterCredentialTypeEq, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * List applications owned by the developer currently logged in.
     * @summary List Applications
     * @param {ApplicationsApiListApplicationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsApi
     */
    ApplicationsApi.prototype.listApplications = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApplicationsApiFp)(this.configuration).listApplications(requestParameters.pageSize, requestParameters.pageNumber, requestParameters.filterNameEq, requestParameters.filterName, requestParameters.filterNameContains, requestParameters.filterAuthStrategyIdEq, requestParameters.filterAuthStrategyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates an application, replacing specified properties with any new values supplied in the request body.
     * @summary Update Application
     * @param {ApplicationsApiUpdateApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsApi
     */
    ApplicationsApi.prototype.updateApplication = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApplicationsApiFp)(this.configuration).updateApplication(requestParameters.applicationId, requestParameters.updateApplicationPayload, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ApplicationsApi;
}(base_1.BaseAPI));
exports.ApplicationsApi = ApplicationsApi;
/**
 * CredentialsApi - axios parameter creator
 * @export
 */
var CredentialsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Allows a developer to create a credential for an application they own.
         * @summary Create Credential for Application
         * @param {string} applicationId Id of the targeted application
         * @param {CreateCredentialPayload} [createCredentialPayload] Create a credential
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCredential: function (applicationId, createCredentialPayload, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'applicationId' is not null or undefined
                    (0, common_1.assertParamExists)('createCredential', 'applicationId', applicationId);
                    localVarPath = "/api/v2/applications/{applicationId}/credentials"
                        .replace("{".concat("applicationId", "}"), encodeURIComponent(String(applicationId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication portalAccessToken required
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createCredentialPayload, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Deletes a credential for an application they own.
         * @summary Delete Credential
         * @param {string} applicationId Id of the targeted application
         * @param {string} credentialId Id of the targeted credential
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCredential: function (applicationId, credentialId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'applicationId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteCredential', 'applicationId', applicationId);
                    // verify required parameter 'credentialId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteCredential', 'credentialId', credentialId);
                    localVarPath = "/api/v2/applications/{applicationId}/credentials/{credentialId}"
                        .replace("{".concat("applicationId", "}"), encodeURIComponent(String(applicationId)))
                        .replace("{".concat("credentialId", "}"), encodeURIComponent(String(credentialId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication portalAccessToken required
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Lists the credentials for an application they own.
         * @summary List credentials
         * @param {string} applicationId Id of the targeted application
         * @param {number} [pageSize] The maximum number of items to include per page. The last page of a collection may include fewer items.
         * @param {number} [pageNumber] Determines which page of the entities to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCredentials: function (applicationId, pageSize, pageNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'applicationId' is not null or undefined
                    (0, common_1.assertParamExists)('listCredentials', 'applicationId', applicationId);
                    localVarPath = "/api/v2/applications/{applicationId}/credentials"
                        .replace("{".concat("applicationId", "}"), encodeURIComponent(String(applicationId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication portalAccessToken required
                    if (pageSize !== undefined) {
                        localVarQueryParameter['page[size]'] = pageSize;
                    }
                    if (pageNumber !== undefined) {
                        localVarQueryParameter['page[number]'] = pageNumber;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Resets the client secret for an application.
         * @summary Refresh Client Secret
         * @param {string} applicationId Id of the targeted application
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshApplicationToken: function (applicationId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'applicationId' is not null or undefined
                    (0, common_1.assertParamExists)('refreshApplicationToken', 'applicationId', applicationId);
                    localVarPath = "/api/v2/applications/{applicationId}/refresh-token"
                        .replace("{".concat("applicationId", "}"), encodeURIComponent(String(applicationId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication portalAccessToken required
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Updates a credential for an application owned by the current logged in developer.
         * @summary Update Credential
         * @param {string} applicationId Id of the targeted application
         * @param {string} credentialId Id of the targeted credential
         * @param {UpdateCredentialPayload} updateCredentialPayload Update a credential
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCredential: function (applicationId, credentialId, updateCredentialPayload, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'applicationId' is not null or undefined
                    (0, common_1.assertParamExists)('updateCredential', 'applicationId', applicationId);
                    // verify required parameter 'credentialId' is not null or undefined
                    (0, common_1.assertParamExists)('updateCredential', 'credentialId', credentialId);
                    // verify required parameter 'updateCredentialPayload' is not null or undefined
                    (0, common_1.assertParamExists)('updateCredential', 'updateCredentialPayload', updateCredentialPayload);
                    localVarPath = "/api/v2/applications/{applicationId}/credentials/{credentialId}"
                        .replace("{".concat("applicationId", "}"), encodeURIComponent(String(applicationId)))
                        .replace("{".concat("credentialId", "}"), encodeURIComponent(String(credentialId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication portalAccessToken required
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateCredentialPayload, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.CredentialsApiAxiosParamCreator = CredentialsApiAxiosParamCreator;
/**
 * CredentialsApi - functional programming interface
 * @export
 */
var CredentialsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CredentialsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Allows a developer to create a credential for an application they own.
         * @summary Create Credential for Application
         * @param {string} applicationId Id of the targeted application
         * @param {CreateCredentialPayload} [createCredentialPayload] Create a credential
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCredential: function (applicationId, createCredentialPayload, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createCredential(applicationId, createCredentialPayload, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Deletes a credential for an application they own.
         * @summary Delete Credential
         * @param {string} applicationId Id of the targeted application
         * @param {string} credentialId Id of the targeted credential
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCredential: function (applicationId, credentialId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteCredential(applicationId, credentialId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Lists the credentials for an application they own.
         * @summary List credentials
         * @param {string} applicationId Id of the targeted application
         * @param {number} [pageSize] The maximum number of items to include per page. The last page of a collection may include fewer items.
         * @param {number} [pageNumber] Determines which page of the entities to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCredentials: function (applicationId, pageSize, pageNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listCredentials(applicationId, pageSize, pageNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Resets the client secret for an application.
         * @summary Refresh Client Secret
         * @param {string} applicationId Id of the targeted application
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshApplicationToken: function (applicationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.refreshApplicationToken(applicationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Updates a credential for an application owned by the current logged in developer.
         * @summary Update Credential
         * @param {string} applicationId Id of the targeted application
         * @param {string} credentialId Id of the targeted credential
         * @param {UpdateCredentialPayload} updateCredentialPayload Update a credential
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCredential: function (applicationId, credentialId, updateCredentialPayload, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateCredential(applicationId, credentialId, updateCredentialPayload, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CredentialsApiFp = CredentialsApiFp;
/**
 * CredentialsApi - factory interface
 * @export
 */
var CredentialsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CredentialsApiFp)(configuration);
    return {
        /**
         * Allows a developer to create a credential for an application they own.
         * @summary Create Credential for Application
         * @param {string} applicationId Id of the targeted application
         * @param {CreateCredentialPayload} [createCredentialPayload] Create a credential
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCredential: function (applicationId, createCredentialPayload, options) {
            return localVarFp.createCredential(applicationId, createCredentialPayload, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Deletes a credential for an application they own.
         * @summary Delete Credential
         * @param {string} applicationId Id of the targeted application
         * @param {string} credentialId Id of the targeted credential
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCredential: function (applicationId, credentialId, options) {
            return localVarFp.deleteCredential(applicationId, credentialId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Lists the credentials for an application they own.
         * @summary List credentials
         * @param {string} applicationId Id of the targeted application
         * @param {number} [pageSize] The maximum number of items to include per page. The last page of a collection may include fewer items.
         * @param {number} [pageNumber] Determines which page of the entities to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCredentials: function (applicationId, pageSize, pageNumber, options) {
            return localVarFp.listCredentials(applicationId, pageSize, pageNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Resets the client secret for an application.
         * @summary Refresh Client Secret
         * @param {string} applicationId Id of the targeted application
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshApplicationToken: function (applicationId, options) {
            return localVarFp.refreshApplicationToken(applicationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates a credential for an application owned by the current logged in developer.
         * @summary Update Credential
         * @param {string} applicationId Id of the targeted application
         * @param {string} credentialId Id of the targeted credential
         * @param {UpdateCredentialPayload} updateCredentialPayload Update a credential
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCredential: function (applicationId, credentialId, updateCredentialPayload, options) {
            return localVarFp.updateCredential(applicationId, credentialId, updateCredentialPayload, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CredentialsApiFactory = CredentialsApiFactory;
/**
 * CredentialsApi - object-oriented interface
 * @export
 * @class CredentialsApi
 * @extends {BaseAPI}
 */
var CredentialsApi = /** @class */ (function (_super) {
    __extends(CredentialsApi, _super);
    function CredentialsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Allows a developer to create a credential for an application they own.
     * @summary Create Credential for Application
     * @param {CredentialsApiCreateCredentialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialsApi
     */
    CredentialsApi.prototype.createCredential = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CredentialsApiFp)(this.configuration).createCredential(requestParameters.applicationId, requestParameters.createCredentialPayload, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Deletes a credential for an application they own.
     * @summary Delete Credential
     * @param {CredentialsApiDeleteCredentialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialsApi
     */
    CredentialsApi.prototype.deleteCredential = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CredentialsApiFp)(this.configuration).deleteCredential(requestParameters.applicationId, requestParameters.credentialId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Lists the credentials for an application they own.
     * @summary List credentials
     * @param {CredentialsApiListCredentialsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialsApi
     */
    CredentialsApi.prototype.listCredentials = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CredentialsApiFp)(this.configuration).listCredentials(requestParameters.applicationId, requestParameters.pageSize, requestParameters.pageNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Resets the client secret for an application.
     * @summary Refresh Client Secret
     * @param {CredentialsApiRefreshApplicationTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialsApi
     */
    CredentialsApi.prototype.refreshApplicationToken = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CredentialsApiFp)(this.configuration).refreshApplicationToken(requestParameters.applicationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates a credential for an application owned by the current logged in developer.
     * @summary Update Credential
     * @param {CredentialsApiUpdateCredentialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialsApi
     */
    CredentialsApi.prototype.updateCredential = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CredentialsApiFp)(this.configuration).updateCredential(requestParameters.applicationId, requestParameters.credentialId, requestParameters.updateCredentialPayload, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CredentialsApi;
}(base_1.BaseAPI));
exports.CredentialsApi = CredentialsApi;
/**
 * DeveloperApi - axios parameter creator
 * @export
 */
var DeveloperApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * This endpoint allows a developer to authenticate to their portal using a username and password.
         * @summary Authenticate
         * @param {AuthenticateRequest} [authenticateRequest] The request schema for the authenticate endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticate: function (authenticateRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v2/developer/authenticate";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(authenticateRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * This endpoint allows a developer to authenticate to their portal using an external IdP.
         * @summary Authenticate SSO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateSso: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v2/developer/authenticate/sso";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Starts the password reset flow for the desired account. An email will be sent to the email address to initiate the password reset flow.
         * @summary Forgot Password
         * @param {ResetPasswordPayload} [resetPasswordPayload] Developer registration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword: function (resetPasswordPayload, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v2/developer/forgot-password";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(resetPasswordPayload, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Returns info about the current developer.
         * @summary Retrieve My Account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeveloperMe: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v2/developer/me";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication portalAccessToken required
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * This endpoint allows a developer to logout of the portal. This operation revokes all active tokens and clears the portal cookies.
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v2/developer/logout";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * This endpoint allows a developer to refresh their existing access token.
         * @summary Refresh Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v2/developer/refresh";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Register to the developer portal.
         * @summary Register
         * @param {{ [key: string]: any; }} [requestBody] Developer registration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register: function (requestBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v2/developer";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * This endpoint allows a developer to reset their password, using a reset token.
         * @summary Reset Password
         * @param {ResetPasswordRequest} [resetPasswordRequest] The request schema for the reset password endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: function (resetPasswordRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v2/developer/reset-password";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(resetPasswordRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * This endpoint allows a new developer to verify their email.
         * @summary Verify Email
         * @param {VerifyEmailRequest} [verifyEmailRequest] The request schema for the verify email endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmail: function (verifyEmailRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v2/developer/verify-email";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(verifyEmailRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DeveloperApiAxiosParamCreator = DeveloperApiAxiosParamCreator;
/**
 * DeveloperApi - functional programming interface
 * @export
 */
var DeveloperApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DeveloperApiAxiosParamCreator)(configuration);
    return {
        /**
         * This endpoint allows a developer to authenticate to their portal using a username and password.
         * @summary Authenticate
         * @param {AuthenticateRequest} [authenticateRequest] The request schema for the authenticate endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticate: function (authenticateRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.authenticate(authenticateRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * This endpoint allows a developer to authenticate to their portal using an external IdP.
         * @summary Authenticate SSO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateSso: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.authenticateSso(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Starts the password reset flow for the desired account. An email will be sent to the email address to initiate the password reset flow.
         * @summary Forgot Password
         * @param {ResetPasswordPayload} [resetPasswordPayload] Developer registration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword: function (resetPasswordPayload, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.forgotPassword(resetPasswordPayload, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns info about the current developer.
         * @summary Retrieve My Account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeveloperMe: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDeveloperMe(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * This endpoint allows a developer to logout of the portal. This operation revokes all active tokens and clears the portal cookies.
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.logout(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * This endpoint allows a developer to refresh their existing access token.
         * @summary Refresh Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.refresh(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Register to the developer portal.
         * @summary Register
         * @param {{ [key: string]: any; }} [requestBody] Developer registration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register: function (requestBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.register(requestBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * This endpoint allows a developer to reset their password, using a reset token.
         * @summary Reset Password
         * @param {ResetPasswordRequest} [resetPasswordRequest] The request schema for the reset password endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: function (resetPasswordRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.resetPassword(resetPasswordRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * This endpoint allows a new developer to verify their email.
         * @summary Verify Email
         * @param {VerifyEmailRequest} [verifyEmailRequest] The request schema for the verify email endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmail: function (verifyEmailRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.verifyEmail(verifyEmailRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DeveloperApiFp = DeveloperApiFp;
/**
 * DeveloperApi - factory interface
 * @export
 */
var DeveloperApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DeveloperApiFp)(configuration);
    return {
        /**
         * This endpoint allows a developer to authenticate to their portal using a username and password.
         * @summary Authenticate
         * @param {AuthenticateRequest} [authenticateRequest] The request schema for the authenticate endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticate: function (authenticateRequest, options) {
            return localVarFp.authenticate(authenticateRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint allows a developer to authenticate to their portal using an external IdP.
         * @summary Authenticate SSO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateSso: function (options) {
            return localVarFp.authenticateSso(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Starts the password reset flow for the desired account. An email will be sent to the email address to initiate the password reset flow.
         * @summary Forgot Password
         * @param {ResetPasswordPayload} [resetPasswordPayload] Developer registration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword: function (resetPasswordPayload, options) {
            return localVarFp.forgotPassword(resetPasswordPayload, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns info about the current developer.
         * @summary Retrieve My Account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeveloperMe: function (options) {
            return localVarFp.getDeveloperMe(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint allows a developer to logout of the portal. This operation revokes all active tokens and clears the portal cookies.
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: function (options) {
            return localVarFp.logout(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint allows a developer to refresh their existing access token.
         * @summary Refresh Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: function (options) {
            return localVarFp.refresh(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Register to the developer portal.
         * @summary Register
         * @param {{ [key: string]: any; }} [requestBody] Developer registration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register: function (requestBody, options) {
            return localVarFp.register(requestBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint allows a developer to reset their password, using a reset token.
         * @summary Reset Password
         * @param {ResetPasswordRequest} [resetPasswordRequest] The request schema for the reset password endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: function (resetPasswordRequest, options) {
            return localVarFp.resetPassword(resetPasswordRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint allows a new developer to verify their email.
         * @summary Verify Email
         * @param {VerifyEmailRequest} [verifyEmailRequest] The request schema for the verify email endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmail: function (verifyEmailRequest, options) {
            return localVarFp.verifyEmail(verifyEmailRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DeveloperApiFactory = DeveloperApiFactory;
/**
 * DeveloperApi - object-oriented interface
 * @export
 * @class DeveloperApi
 * @extends {BaseAPI}
 */
var DeveloperApi = /** @class */ (function (_super) {
    __extends(DeveloperApi, _super);
    function DeveloperApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This endpoint allows a developer to authenticate to their portal using a username and password.
     * @summary Authenticate
     * @param {DeveloperApiAuthenticateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeveloperApi
     */
    DeveloperApi.prototype.authenticate = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DeveloperApiFp)(this.configuration).authenticate(requestParameters.authenticateRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint allows a developer to authenticate to their portal using an external IdP.
     * @summary Authenticate SSO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeveloperApi
     */
    DeveloperApi.prototype.authenticateSso = function (options) {
        var _this = this;
        return (0, exports.DeveloperApiFp)(this.configuration).authenticateSso(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Starts the password reset flow for the desired account. An email will be sent to the email address to initiate the password reset flow.
     * @summary Forgot Password
     * @param {DeveloperApiForgotPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeveloperApi
     */
    DeveloperApi.prototype.forgotPassword = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DeveloperApiFp)(this.configuration).forgotPassword(requestParameters.resetPasswordPayload, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns info about the current developer.
     * @summary Retrieve My Account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeveloperApi
     */
    DeveloperApi.prototype.getDeveloperMe = function (options) {
        var _this = this;
        return (0, exports.DeveloperApiFp)(this.configuration).getDeveloperMe(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint allows a developer to logout of the portal. This operation revokes all active tokens and clears the portal cookies.
     * @summary Logout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeveloperApi
     */
    DeveloperApi.prototype.logout = function (options) {
        var _this = this;
        return (0, exports.DeveloperApiFp)(this.configuration).logout(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint allows a developer to refresh their existing access token.
     * @summary Refresh Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeveloperApi
     */
    DeveloperApi.prototype.refresh = function (options) {
        var _this = this;
        return (0, exports.DeveloperApiFp)(this.configuration).refresh(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Register to the developer portal.
     * @summary Register
     * @param {DeveloperApiRegisterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeveloperApi
     */
    DeveloperApi.prototype.register = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DeveloperApiFp)(this.configuration).register(requestParameters.requestBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint allows a developer to reset their password, using a reset token.
     * @summary Reset Password
     * @param {DeveloperApiResetPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeveloperApi
     */
    DeveloperApi.prototype.resetPassword = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DeveloperApiFp)(this.configuration).resetPassword(requestParameters.resetPasswordRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint allows a new developer to verify their email.
     * @summary Verify Email
     * @param {DeveloperApiVerifyEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeveloperApi
     */
    DeveloperApi.prototype.verifyEmail = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DeveloperApiFp)(this.configuration).verifyEmail(requestParameters.verifyEmailRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DeveloperApi;
}(base_1.BaseAPI));
exports.DeveloperApi = DeveloperApi;
/**
 * DocumentationApi - axios parameter creator
 * @export
 */
var DocumentationApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Returns the specified document from the product\'s document tree.
         * @summary Get one product document
         * @param {string} productId Contains a unique identifier used by the Portal API for this resource.
         * @param {string} documentId Contains a unique identifier used by the Portal API for this resource.
         * @param {DocumentFormatContentTypeEnum} [accept]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductDocument: function (productId, documentId, accept, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'productId' is not null or undefined
                    (0, common_1.assertParamExists)('getProductDocument', 'productId', productId);
                    // verify required parameter 'documentId' is not null or undefined
                    (0, common_1.assertParamExists)('getProductDocument', 'documentId', documentId);
                    localVarPath = "/api/v2/products/{productId}/documents/{documentId}"
                        .replace("{".concat("productId", "}"), encodeURIComponent(String(productId)))
                        .replace("{".concat("documentId", "}"), encodeURIComponent(String(documentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication portalAccessToken required
                    if (accept != null) {
                        localVarHeaderParameter['Accept'] = typeof accept === 'string'
                            ? accept
                            : JSON.stringify(accept);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Returns a list of documents that are associated with a given product. The list is paginated, and is in either a list or tree format (based on the Accept header).
         * @summary List product documents
         * @param {string} productId Contains a unique identifier used by the Portal API for this resource.
         * @param {DocumentContentTypeEnum} [accept]
         * @param {number} [pageSize] The maximum number of items to include per page. The last page of a collection may include fewer items.
         * @param {number} [pageNumber] Determines which page of the entities to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProductDocuments: function (productId, accept, pageSize, pageNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'productId' is not null or undefined
                    (0, common_1.assertParamExists)('listProductDocuments', 'productId', productId);
                    localVarPath = "/api/v2/products/{productId}/documents"
                        .replace("{".concat("productId", "}"), encodeURIComponent(String(productId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication portalAccessToken required
                    if (pageSize !== undefined) {
                        localVarQueryParameter['page[size]'] = pageSize;
                    }
                    if (pageNumber !== undefined) {
                        localVarQueryParameter['page[number]'] = pageNumber;
                    }
                    if (accept != null) {
                        localVarHeaderParameter['Accept'] = typeof accept === 'string'
                            ? accept
                            : JSON.stringify(accept);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DocumentationApiAxiosParamCreator = DocumentationApiAxiosParamCreator;
/**
 * DocumentationApi - functional programming interface
 * @export
 */
var DocumentationApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DocumentationApiAxiosParamCreator)(configuration);
    return {
        /**
         * Returns the specified document from the product\'s document tree.
         * @summary Get one product document
         * @param {string} productId Contains a unique identifier used by the Portal API for this resource.
         * @param {string} documentId Contains a unique identifier used by the Portal API for this resource.
         * @param {DocumentFormatContentTypeEnum} [accept]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductDocument: function (productId, documentId, accept, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProductDocument(productId, documentId, accept, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns a list of documents that are associated with a given product. The list is paginated, and is in either a list or tree format (based on the Accept header).
         * @summary List product documents
         * @param {string} productId Contains a unique identifier used by the Portal API for this resource.
         * @param {DocumentContentTypeEnum} [accept]
         * @param {number} [pageSize] The maximum number of items to include per page. The last page of a collection may include fewer items.
         * @param {number} [pageNumber] Determines which page of the entities to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProductDocuments: function (productId, accept, pageSize, pageNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listProductDocuments(productId, accept, pageSize, pageNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DocumentationApiFp = DocumentationApiFp;
/**
 * DocumentationApi - factory interface
 * @export
 */
var DocumentationApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DocumentationApiFp)(configuration);
    return {
        /**
         * Returns the specified document from the product\'s document tree.
         * @summary Get one product document
         * @param {string} productId Contains a unique identifier used by the Portal API for this resource.
         * @param {string} documentId Contains a unique identifier used by the Portal API for this resource.
         * @param {DocumentFormatContentTypeEnum} [accept]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductDocument: function (productId, documentId, accept, options) {
            return localVarFp.getProductDocument(productId, documentId, accept, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a list of documents that are associated with a given product. The list is paginated, and is in either a list or tree format (based on the Accept header).
         * @summary List product documents
         * @param {string} productId Contains a unique identifier used by the Portal API for this resource.
         * @param {DocumentContentTypeEnum} [accept]
         * @param {number} [pageSize] The maximum number of items to include per page. The last page of a collection may include fewer items.
         * @param {number} [pageNumber] Determines which page of the entities to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProductDocuments: function (productId, accept, pageSize, pageNumber, options) {
            return localVarFp.listProductDocuments(productId, accept, pageSize, pageNumber, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DocumentationApiFactory = DocumentationApiFactory;
/**
 * DocumentationApi - object-oriented interface
 * @export
 * @class DocumentationApi
 * @extends {BaseAPI}
 */
var DocumentationApi = /** @class */ (function (_super) {
    __extends(DocumentationApi, _super);
    function DocumentationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns the specified document from the product\'s document tree.
     * @summary Get one product document
     * @param {DocumentationApiGetProductDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentationApi
     */
    DocumentationApi.prototype.getProductDocument = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DocumentationApiFp)(this.configuration).getProductDocument(requestParameters.productId, requestParameters.documentId, requestParameters.accept, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a list of documents that are associated with a given product. The list is paginated, and is in either a list or tree format (based on the Accept header).
     * @summary List product documents
     * @param {DocumentationApiListProductDocumentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentationApi
     */
    DocumentationApi.prototype.listProductDocuments = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DocumentationApiFp)(this.configuration).listProductDocuments(requestParameters.productId, requestParameters.accept, requestParameters.pageSize, requestParameters.pageNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DocumentationApi;
}(base_1.BaseAPI));
exports.DocumentationApi = DocumentationApi;
/**
 * PortalApi - axios parameter creator
 * @export
 */
var PortalApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Gets appearance configuration object for the portal. This object is set in Konnect.
         * @summary Portal Appearance Details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortalAppearance: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v2/portal/appearance";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Gets cover banner for the developer portal. This object is set in Konnect.
         * @summary Portal Catalog Cover Banner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortalCatalogCover: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v2/portal/catalog-cover";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Return the portal context object.
         * @summary Get portal context
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortalContext: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v2/portal";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Gets logo of the developer portal. This object is set in Konnect.
         * @summary Portal Logo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortalLogo: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v2/portal/logo";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.PortalApiAxiosParamCreator = PortalApiAxiosParamCreator;
/**
 * PortalApi - functional programming interface
 * @export
 */
var PortalApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PortalApiAxiosParamCreator)(configuration);
    return {
        /**
         * Gets appearance configuration object for the portal. This object is set in Konnect.
         * @summary Portal Appearance Details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortalAppearance: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPortalAppearance(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Gets cover banner for the developer portal. This object is set in Konnect.
         * @summary Portal Catalog Cover Banner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortalCatalogCover: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPortalCatalogCover(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Return the portal context object.
         * @summary Get portal context
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortalContext: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPortalContext(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Gets logo of the developer portal. This object is set in Konnect.
         * @summary Portal Logo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortalLogo: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPortalLogo(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.PortalApiFp = PortalApiFp;
/**
 * PortalApi - factory interface
 * @export
 */
var PortalApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PortalApiFp)(configuration);
    return {
        /**
         * Gets appearance configuration object for the portal. This object is set in Konnect.
         * @summary Portal Appearance Details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortalAppearance: function (options) {
            return localVarFp.getPortalAppearance(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Gets cover banner for the developer portal. This object is set in Konnect.
         * @summary Portal Catalog Cover Banner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortalCatalogCover: function (options) {
            return localVarFp.getPortalCatalogCover(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return the portal context object.
         * @summary Get portal context
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortalContext: function (options) {
            return localVarFp.getPortalContext(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Gets logo of the developer portal. This object is set in Konnect.
         * @summary Portal Logo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortalLogo: function (options) {
            return localVarFp.getPortalLogo(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PortalApiFactory = PortalApiFactory;
/**
 * PortalApi - object-oriented interface
 * @export
 * @class PortalApi
 * @extends {BaseAPI}
 */
var PortalApi = /** @class */ (function (_super) {
    __extends(PortalApi, _super);
    function PortalApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Gets appearance configuration object for the portal. This object is set in Konnect.
     * @summary Portal Appearance Details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    PortalApi.prototype.getPortalAppearance = function (options) {
        var _this = this;
        return (0, exports.PortalApiFp)(this.configuration).getPortalAppearance(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Gets cover banner for the developer portal. This object is set in Konnect.
     * @summary Portal Catalog Cover Banner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    PortalApi.prototype.getPortalCatalogCover = function (options) {
        var _this = this;
        return (0, exports.PortalApiFp)(this.configuration).getPortalCatalogCover(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return the portal context object.
     * @summary Get portal context
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    PortalApi.prototype.getPortalContext = function (options) {
        var _this = this;
        return (0, exports.PortalApiFp)(this.configuration).getPortalContext(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Gets logo of the developer portal. This object is set in Konnect.
     * @summary Portal Logo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    PortalApi.prototype.getPortalLogo = function (options) {
        var _this = this;
        return (0, exports.PortalApiFp)(this.configuration).getPortalLogo(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PortalApi;
}(base_1.BaseAPI));
exports.PortalApi = PortalApi;
/**
 * ProductsApi - axios parameter creator
 * @export
 */
var ProductsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Gets the details for an existing published product.
         * @summary Get a product
         * @param {string} productId Contains a unique identifier used by the Portal API for this resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduct: function (productId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'productId' is not null or undefined
                    (0, common_1.assertParamExists)('getProduct', 'productId', productId);
                    localVarPath = "/api/v2/products/{productId}"
                        .replace("{".concat("productId", "}"), encodeURIComponent(String(productId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication portalAccessToken required
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get a list of actions that the current developer is allowed to perform on an API product.
         * @summary Get Product Actions
         * @param {string} productId Contains a unique identifier used by the Portal API for this resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductActions: function (productId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'productId' is not null or undefined
                    (0, common_1.assertParamExists)('getProductActions', 'productId', productId);
                    localVarPath = "/api/v2/products/{productId}/actions"
                        .replace("{".concat("productId", "}"), encodeURIComponent(String(productId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Returns a paginated list of published API Products.
         * @summary List Products
         * @param {number} [pageSize] The maximum number of items to include per page. The last page of a collection may include fewer items.
         * @param {number} [pageNumber] Determines which page of the entities to retrieve.
         * @param {string} [filterNameEq] Filter by direct equality comparison of the name property with a supplied value.
         * @param {string} [filterName] Filter by direct equality comparison (short-hand) of the name property with a supplied value.
         * @param {string} [filterNameContains] Filter by contains comparison of the name property with a supplied substring
         * @param {string} [filterDescriptionEq] Filter by direct equality comparison of the description property with a supplied value.
         * @param {string} [filterDescription] Filter by direct equality comparison (short-hand) of the description property with a supplied value.
         * @param {string} [filterDescriptionContains] Filter by contains comparison of the description property with a supplied substring
         * @param {string} [filterIdEq] Filter by direct equality comparison of the id property with a supplied value.
         * @param {string} [filterId] Filter by direct equality comparison (short-hand) of the id property with a supplied value.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProducts: function (pageSize, pageNumber, filterNameEq, filterName, filterNameContains, filterDescriptionEq, filterDescription, filterDescriptionContains, filterIdEq, filterId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v2/products";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication portalAccessToken required
                    if (pageSize !== undefined) {
                        localVarQueryParameter['page[size]'] = pageSize;
                    }
                    if (pageNumber !== undefined) {
                        localVarQueryParameter['page[number]'] = pageNumber;
                    }
                    if (filterNameEq !== undefined) {
                        localVarQueryParameter['filter[name][eq]'] = filterNameEq;
                    }
                    if (filterName !== undefined) {
                        localVarQueryParameter['filter[name]'] = filterName;
                    }
                    if (filterNameContains !== undefined) {
                        localVarQueryParameter['filter[name][contains]'] = filterNameContains;
                    }
                    if (filterDescriptionEq !== undefined) {
                        localVarQueryParameter['filter[description][eq]'] = filterDescriptionEq;
                    }
                    if (filterDescription !== undefined) {
                        localVarQueryParameter['filter[description]'] = filterDescription;
                    }
                    if (filterDescriptionContains !== undefined) {
                        localVarQueryParameter['filter[description][contains]'] = filterDescriptionContains;
                    }
                    if (filterIdEq !== undefined) {
                        localVarQueryParameter['filter[id][eq]'] = filterIdEq;
                    }
                    if (filterId !== undefined) {
                        localVarQueryParameter['filter[id]'] = filterId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.ProductsApiAxiosParamCreator = ProductsApiAxiosParamCreator;
/**
 * ProductsApi - functional programming interface
 * @export
 */
var ProductsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ProductsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Gets the details for an existing published product.
         * @summary Get a product
         * @param {string} productId Contains a unique identifier used by the Portal API for this resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduct: function (productId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProduct(productId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get a list of actions that the current developer is allowed to perform on an API product.
         * @summary Get Product Actions
         * @param {string} productId Contains a unique identifier used by the Portal API for this resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductActions: function (productId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProductActions(productId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns a paginated list of published API Products.
         * @summary List Products
         * @param {number} [pageSize] The maximum number of items to include per page. The last page of a collection may include fewer items.
         * @param {number} [pageNumber] Determines which page of the entities to retrieve.
         * @param {string} [filterNameEq] Filter by direct equality comparison of the name property with a supplied value.
         * @param {string} [filterName] Filter by direct equality comparison (short-hand) of the name property with a supplied value.
         * @param {string} [filterNameContains] Filter by contains comparison of the name property with a supplied substring
         * @param {string} [filterDescriptionEq] Filter by direct equality comparison of the description property with a supplied value.
         * @param {string} [filterDescription] Filter by direct equality comparison (short-hand) of the description property with a supplied value.
         * @param {string} [filterDescriptionContains] Filter by contains comparison of the description property with a supplied substring
         * @param {string} [filterIdEq] Filter by direct equality comparison of the id property with a supplied value.
         * @param {string} [filterId] Filter by direct equality comparison (short-hand) of the id property with a supplied value.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProducts: function (pageSize, pageNumber, filterNameEq, filterName, filterNameContains, filterDescriptionEq, filterDescription, filterDescriptionContains, filterIdEq, filterId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listProducts(pageSize, pageNumber, filterNameEq, filterName, filterNameContains, filterDescriptionEq, filterDescription, filterDescriptionContains, filterIdEq, filterId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ProductsApiFp = ProductsApiFp;
/**
 * ProductsApi - factory interface
 * @export
 */
var ProductsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ProductsApiFp)(configuration);
    return {
        /**
         * Gets the details for an existing published product.
         * @summary Get a product
         * @param {string} productId Contains a unique identifier used by the Portal API for this resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduct: function (productId, options) {
            return localVarFp.getProduct(productId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a list of actions that the current developer is allowed to perform on an API product.
         * @summary Get Product Actions
         * @param {string} productId Contains a unique identifier used by the Portal API for this resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductActions: function (productId, options) {
            return localVarFp.getProductActions(productId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a paginated list of published API Products.
         * @summary List Products
         * @param {number} [pageSize] The maximum number of items to include per page. The last page of a collection may include fewer items.
         * @param {number} [pageNumber] Determines which page of the entities to retrieve.
         * @param {string} [filterNameEq] Filter by direct equality comparison of the name property with a supplied value.
         * @param {string} [filterName] Filter by direct equality comparison (short-hand) of the name property with a supplied value.
         * @param {string} [filterNameContains] Filter by contains comparison of the name property with a supplied substring
         * @param {string} [filterDescriptionEq] Filter by direct equality comparison of the description property with a supplied value.
         * @param {string} [filterDescription] Filter by direct equality comparison (short-hand) of the description property with a supplied value.
         * @param {string} [filterDescriptionContains] Filter by contains comparison of the description property with a supplied substring
         * @param {string} [filterIdEq] Filter by direct equality comparison of the id property with a supplied value.
         * @param {string} [filterId] Filter by direct equality comparison (short-hand) of the id property with a supplied value.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProducts: function (pageSize, pageNumber, filterNameEq, filterName, filterNameContains, filterDescriptionEq, filterDescription, filterDescriptionContains, filterIdEq, filterId, options) {
            return localVarFp.listProducts(pageSize, pageNumber, filterNameEq, filterName, filterNameContains, filterDescriptionEq, filterDescription, filterDescriptionContains, filterIdEq, filterId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ProductsApiFactory = ProductsApiFactory;
/**
 * ProductsApi - object-oriented interface
 * @export
 * @class ProductsApi
 * @extends {BaseAPI}
 */
var ProductsApi = /** @class */ (function (_super) {
    __extends(ProductsApi, _super);
    function ProductsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Gets the details for an existing published product.
     * @summary Get a product
     * @param {ProductsApiGetProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    ProductsApi.prototype.getProduct = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ProductsApiFp)(this.configuration).getProduct(requestParameters.productId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a list of actions that the current developer is allowed to perform on an API product.
     * @summary Get Product Actions
     * @param {ProductsApiGetProductActionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    ProductsApi.prototype.getProductActions = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ProductsApiFp)(this.configuration).getProductActions(requestParameters.productId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a paginated list of published API Products.
     * @summary List Products
     * @param {ProductsApiListProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    ProductsApi.prototype.listProducts = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ProductsApiFp)(this.configuration).listProducts(requestParameters.pageSize, requestParameters.pageNumber, requestParameters.filterNameEq, requestParameters.filterName, requestParameters.filterNameContains, requestParameters.filterDescriptionEq, requestParameters.filterDescription, requestParameters.filterDescriptionContains, requestParameters.filterIdEq, requestParameters.filterId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ProductsApi;
}(base_1.BaseAPI));
exports.ProductsApi = ProductsApi;
/**
 * RegistrationsApi - axios parameter creator
 * @export
 */
var RegistrationsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Registers an application for a product.
         * @summary Register an application for a product
         * @param {string} applicationId Id of the targeted application
         * @param {CreateRegistrationPayload} createRegistrationPayload Create an application registration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApplicationRegistration: function (applicationId, createRegistrationPayload, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'applicationId' is not null or undefined
                    (0, common_1.assertParamExists)('createApplicationRegistration', 'applicationId', applicationId);
                    // verify required parameter 'createRegistrationPayload' is not null or undefined
                    (0, common_1.assertParamExists)('createApplicationRegistration', 'createRegistrationPayload', createRegistrationPayload);
                    localVarPath = "/api/v2/applications/{applicationId}/registrations"
                        .replace("{".concat("applicationId", "}"), encodeURIComponent(String(applicationId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication portalAccessToken required
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createRegistrationPayload, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Unregister an application for a product version.
         * @summary Delete an application registration
         * @param {string} applicationId Id of the targeted application
         * @param {string} registrationId Contains a unique identifier used by the Portal API for this resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApplicationRegistration: function (applicationId, registrationId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'applicationId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteApplicationRegistration', 'applicationId', applicationId);
                    // verify required parameter 'registrationId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteApplicationRegistration', 'registrationId', registrationId);
                    localVarPath = "/api/v2/applications/{applicationId}/registrations/{registrationId}"
                        .replace("{".concat("applicationId", "}"), encodeURIComponent(String(applicationId)))
                        .replace("{".concat("registrationId", "}"), encodeURIComponent(String(registrationId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication portalAccessToken required
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Retrieves the specified product registration for an application.
         * @summary Get an application registration
         * @param {string} applicationId Id of the targeted application
         * @param {string} registrationId Contains a unique identifier used by the Portal API for this resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationRegistration: function (applicationId, registrationId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'applicationId' is not null or undefined
                    (0, common_1.assertParamExists)('getApplicationRegistration', 'applicationId', applicationId);
                    // verify required parameter 'registrationId' is not null or undefined
                    (0, common_1.assertParamExists)('getApplicationRegistration', 'registrationId', registrationId);
                    localVarPath = "/api/v2/applications/{applicationId}/registrations/{registrationId}"
                        .replace("{".concat("applicationId", "}"), encodeURIComponent(String(applicationId)))
                        .replace("{".concat("registrationId", "}"), encodeURIComponent(String(registrationId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication portalAccessToken required
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Retrieves the granted scopes of a specified product registration directly from the IDP for an application. Will return 409 if this feature is not supported by the application.
         * @summary Get the granted scopes of an application registration
         * @param {string} applicationId Id of the targeted application
         * @param {string} registrationId Contains a unique identifier used by the Portal API for this resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationRegistrationGrantedScopes: function (applicationId, registrationId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'applicationId' is not null or undefined
                    (0, common_1.assertParamExists)('getApplicationRegistrationGrantedScopes', 'applicationId', applicationId);
                    // verify required parameter 'registrationId' is not null or undefined
                    (0, common_1.assertParamExists)('getApplicationRegistrationGrantedScopes', 'registrationId', registrationId);
                    localVarPath = "/api/v2/applications/{applicationId}/registrations/{registrationId}/granted-scopes"
                        .replace("{".concat("applicationId", "}"), encodeURIComponent(String(applicationId)))
                        .replace("{".concat("registrationId", "}"), encodeURIComponent(String(registrationId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication portalAccessToken required
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Lists product registrations for an application.
         * @summary Get application registrations
         * @param {string} applicationId Id of the targeted application
         * @param {number} [pageSize] The maximum number of items to include per page. The last page of a collection may include fewer items.
         * @param {number} [pageNumber] Determines which page of the entities to retrieve.
         * @param {string} [filterIdEq] Filter by direct equality comparison of the id property with a supplied value.
         * @param {string} [filterId] Filter by direct equality comparison (short-hand) of the id property with a supplied value.
         * @param {'approved' | 'pending' | 'rejected' | 'revoked'} [filterStatusEq] Filter by direct equality comparison of the status property with a supplied value.
         * @param {'approved' | 'pending' | 'rejected' | 'revoked'} [filterStatus] Filter by direct equality comparison (short-hand) of the status property with a supplied value.
         * @param {string} [filterProductNameEq] Filter by direct equality comparison of the product_name property with a supplied value.
         * @param {string} [filterProductName] Filter by direct equality comparison (short-hand) of the product_name property with a supplied value.
         * @param {string} [filterProductVersionNameEq] Filter by direct equality comparison of the product_version_name property with a supplied value.
         * @param {string} [filterProductVersionName] Filter by direct equality comparison (short-hand) of the product_version_name property with a supplied value.
         * @param {string} [filterProductVersionNameContains] Filter by contains comparison of the product_version_name property with a supplied substring
         * @param {string} [filterProductNameContains] Filter by contains comparison of the product_name property with a supplied substring
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApplicationRegistrations: function (applicationId, pageSize, pageNumber, filterIdEq, filterId, filterStatusEq, filterStatus, filterProductNameEq, filterProductName, filterProductVersionNameEq, filterProductVersionName, filterProductVersionNameContains, filterProductNameContains, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'applicationId' is not null or undefined
                    (0, common_1.assertParamExists)('listApplicationRegistrations', 'applicationId', applicationId);
                    localVarPath = "/api/v2/applications/{applicationId}/registrations"
                        .replace("{".concat("applicationId", "}"), encodeURIComponent(String(applicationId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication portalAccessToken required
                    if (pageSize !== undefined) {
                        localVarQueryParameter['page[size]'] = pageSize;
                    }
                    if (pageNumber !== undefined) {
                        localVarQueryParameter['page[number]'] = pageNumber;
                    }
                    if (filterIdEq !== undefined) {
                        localVarQueryParameter['filter[id][eq]'] = filterIdEq;
                    }
                    if (filterId !== undefined) {
                        localVarQueryParameter['filter[id]'] = filterId;
                    }
                    if (filterStatusEq !== undefined) {
                        localVarQueryParameter['filter[status][eq]'] = filterStatusEq;
                    }
                    if (filterStatus !== undefined) {
                        localVarQueryParameter['filter[status]'] = filterStatus;
                    }
                    if (filterProductNameEq !== undefined) {
                        localVarQueryParameter['filter[product_name][eq]'] = filterProductNameEq;
                    }
                    if (filterProductName !== undefined) {
                        localVarQueryParameter['filter[product_name]'] = filterProductName;
                    }
                    if (filterProductVersionNameEq !== undefined) {
                        localVarQueryParameter['filter[product_version_name][eq]'] = filterProductVersionNameEq;
                    }
                    if (filterProductVersionName !== undefined) {
                        localVarQueryParameter['filter[product_version_name]'] = filterProductVersionName;
                    }
                    if (filterProductVersionNameContains !== undefined) {
                        localVarQueryParameter['filter[product_version_name][contains]'] = filterProductVersionNameContains;
                    }
                    if (filterProductNameContains !== undefined) {
                        localVarQueryParameter['filter[product_name][contains]'] = filterProductNameContains;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.RegistrationsApiAxiosParamCreator = RegistrationsApiAxiosParamCreator;
/**
 * RegistrationsApi - functional programming interface
 * @export
 */
var RegistrationsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.RegistrationsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Registers an application for a product.
         * @summary Register an application for a product
         * @param {string} applicationId Id of the targeted application
         * @param {CreateRegistrationPayload} createRegistrationPayload Create an application registration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApplicationRegistration: function (applicationId, createRegistrationPayload, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createApplicationRegistration(applicationId, createRegistrationPayload, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Unregister an application for a product version.
         * @summary Delete an application registration
         * @param {string} applicationId Id of the targeted application
         * @param {string} registrationId Contains a unique identifier used by the Portal API for this resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApplicationRegistration: function (applicationId, registrationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteApplicationRegistration(applicationId, registrationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieves the specified product registration for an application.
         * @summary Get an application registration
         * @param {string} applicationId Id of the targeted application
         * @param {string} registrationId Contains a unique identifier used by the Portal API for this resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationRegistration: function (applicationId, registrationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getApplicationRegistration(applicationId, registrationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieves the granted scopes of a specified product registration directly from the IDP for an application. Will return 409 if this feature is not supported by the application.
         * @summary Get the granted scopes of an application registration
         * @param {string} applicationId Id of the targeted application
         * @param {string} registrationId Contains a unique identifier used by the Portal API for this resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationRegistrationGrantedScopes: function (applicationId, registrationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getApplicationRegistrationGrantedScopes(applicationId, registrationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Lists product registrations for an application.
         * @summary Get application registrations
         * @param {string} applicationId Id of the targeted application
         * @param {number} [pageSize] The maximum number of items to include per page. The last page of a collection may include fewer items.
         * @param {number} [pageNumber] Determines which page of the entities to retrieve.
         * @param {string} [filterIdEq] Filter by direct equality comparison of the id property with a supplied value.
         * @param {string} [filterId] Filter by direct equality comparison (short-hand) of the id property with a supplied value.
         * @param {'approved' | 'pending' | 'rejected' | 'revoked'} [filterStatusEq] Filter by direct equality comparison of the status property with a supplied value.
         * @param {'approved' | 'pending' | 'rejected' | 'revoked'} [filterStatus] Filter by direct equality comparison (short-hand) of the status property with a supplied value.
         * @param {string} [filterProductNameEq] Filter by direct equality comparison of the product_name property with a supplied value.
         * @param {string} [filterProductName] Filter by direct equality comparison (short-hand) of the product_name property with a supplied value.
         * @param {string} [filterProductVersionNameEq] Filter by direct equality comparison of the product_version_name property with a supplied value.
         * @param {string} [filterProductVersionName] Filter by direct equality comparison (short-hand) of the product_version_name property with a supplied value.
         * @param {string} [filterProductVersionNameContains] Filter by contains comparison of the product_version_name property with a supplied substring
         * @param {string} [filterProductNameContains] Filter by contains comparison of the product_name property with a supplied substring
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApplicationRegistrations: function (applicationId, pageSize, pageNumber, filterIdEq, filterId, filterStatusEq, filterStatus, filterProductNameEq, filterProductName, filterProductVersionNameEq, filterProductVersionName, filterProductVersionNameContains, filterProductNameContains, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listApplicationRegistrations(applicationId, pageSize, pageNumber, filterIdEq, filterId, filterStatusEq, filterStatus, filterProductNameEq, filterProductName, filterProductVersionNameEq, filterProductVersionName, filterProductVersionNameContains, filterProductNameContains, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.RegistrationsApiFp = RegistrationsApiFp;
/**
 * RegistrationsApi - factory interface
 * @export
 */
var RegistrationsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.RegistrationsApiFp)(configuration);
    return {
        /**
         * Registers an application for a product.
         * @summary Register an application for a product
         * @param {string} applicationId Id of the targeted application
         * @param {CreateRegistrationPayload} createRegistrationPayload Create an application registration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApplicationRegistration: function (applicationId, createRegistrationPayload, options) {
            return localVarFp.createApplicationRegistration(applicationId, createRegistrationPayload, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Unregister an application for a product version.
         * @summary Delete an application registration
         * @param {string} applicationId Id of the targeted application
         * @param {string} registrationId Contains a unique identifier used by the Portal API for this resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApplicationRegistration: function (applicationId, registrationId, options) {
            return localVarFp.deleteApplicationRegistration(applicationId, registrationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieves the specified product registration for an application.
         * @summary Get an application registration
         * @param {string} applicationId Id of the targeted application
         * @param {string} registrationId Contains a unique identifier used by the Portal API for this resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationRegistration: function (applicationId, registrationId, options) {
            return localVarFp.getApplicationRegistration(applicationId, registrationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieves the granted scopes of a specified product registration directly from the IDP for an application. Will return 409 if this feature is not supported by the application.
         * @summary Get the granted scopes of an application registration
         * @param {string} applicationId Id of the targeted application
         * @param {string} registrationId Contains a unique identifier used by the Portal API for this resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationRegistrationGrantedScopes: function (applicationId, registrationId, options) {
            return localVarFp.getApplicationRegistrationGrantedScopes(applicationId, registrationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Lists product registrations for an application.
         * @summary Get application registrations
         * @param {string} applicationId Id of the targeted application
         * @param {number} [pageSize] The maximum number of items to include per page. The last page of a collection may include fewer items.
         * @param {number} [pageNumber] Determines which page of the entities to retrieve.
         * @param {string} [filterIdEq] Filter by direct equality comparison of the id property with a supplied value.
         * @param {string} [filterId] Filter by direct equality comparison (short-hand) of the id property with a supplied value.
         * @param {'approved' | 'pending' | 'rejected' | 'revoked'} [filterStatusEq] Filter by direct equality comparison of the status property with a supplied value.
         * @param {'approved' | 'pending' | 'rejected' | 'revoked'} [filterStatus] Filter by direct equality comparison (short-hand) of the status property with a supplied value.
         * @param {string} [filterProductNameEq] Filter by direct equality comparison of the product_name property with a supplied value.
         * @param {string} [filterProductName] Filter by direct equality comparison (short-hand) of the product_name property with a supplied value.
         * @param {string} [filterProductVersionNameEq] Filter by direct equality comparison of the product_version_name property with a supplied value.
         * @param {string} [filterProductVersionName] Filter by direct equality comparison (short-hand) of the product_version_name property with a supplied value.
         * @param {string} [filterProductVersionNameContains] Filter by contains comparison of the product_version_name property with a supplied substring
         * @param {string} [filterProductNameContains] Filter by contains comparison of the product_name property with a supplied substring
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApplicationRegistrations: function (applicationId, pageSize, pageNumber, filterIdEq, filterId, filterStatusEq, filterStatus, filterProductNameEq, filterProductName, filterProductVersionNameEq, filterProductVersionName, filterProductVersionNameContains, filterProductNameContains, options) {
            return localVarFp.listApplicationRegistrations(applicationId, pageSize, pageNumber, filterIdEq, filterId, filterStatusEq, filterStatus, filterProductNameEq, filterProductName, filterProductVersionNameEq, filterProductVersionName, filterProductVersionNameContains, filterProductNameContains, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.RegistrationsApiFactory = RegistrationsApiFactory;
/**
 * RegistrationsApi - object-oriented interface
 * @export
 * @class RegistrationsApi
 * @extends {BaseAPI}
 */
var RegistrationsApi = /** @class */ (function (_super) {
    __extends(RegistrationsApi, _super);
    function RegistrationsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Registers an application for a product.
     * @summary Register an application for a product
     * @param {RegistrationsApiCreateApplicationRegistrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationsApi
     */
    RegistrationsApi.prototype.createApplicationRegistration = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RegistrationsApiFp)(this.configuration).createApplicationRegistration(requestParameters.applicationId, requestParameters.createRegistrationPayload, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Unregister an application for a product version.
     * @summary Delete an application registration
     * @param {RegistrationsApiDeleteApplicationRegistrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationsApi
     */
    RegistrationsApi.prototype.deleteApplicationRegistration = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RegistrationsApiFp)(this.configuration).deleteApplicationRegistration(requestParameters.applicationId, requestParameters.registrationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieves the specified product registration for an application.
     * @summary Get an application registration
     * @param {RegistrationsApiGetApplicationRegistrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationsApi
     */
    RegistrationsApi.prototype.getApplicationRegistration = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RegistrationsApiFp)(this.configuration).getApplicationRegistration(requestParameters.applicationId, requestParameters.registrationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieves the granted scopes of a specified product registration directly from the IDP for an application. Will return 409 if this feature is not supported by the application.
     * @summary Get the granted scopes of an application registration
     * @param {RegistrationsApiGetApplicationRegistrationGrantedScopesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationsApi
     */
    RegistrationsApi.prototype.getApplicationRegistrationGrantedScopes = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RegistrationsApiFp)(this.configuration).getApplicationRegistrationGrantedScopes(requestParameters.applicationId, requestParameters.registrationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Lists product registrations for an application.
     * @summary Get application registrations
     * @param {RegistrationsApiListApplicationRegistrationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationsApi
     */
    RegistrationsApi.prototype.listApplicationRegistrations = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RegistrationsApiFp)(this.configuration).listApplicationRegistrations(requestParameters.applicationId, requestParameters.pageSize, requestParameters.pageNumber, requestParameters.filterIdEq, requestParameters.filterId, requestParameters.filterStatusEq, requestParameters.filterStatus, requestParameters.filterProductNameEq, requestParameters.filterProductName, requestParameters.filterProductVersionNameEq, requestParameters.filterProductVersionName, requestParameters.filterProductVersionNameContains, requestParameters.filterProductNameContains, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return RegistrationsApi;
}(base_1.BaseAPI));
exports.RegistrationsApi = RegistrationsApi;
/**
 * SearchApi - axios parameter creator
 * @export
 */
var SearchApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Returns paginated search results from the specified entities with the given search parameters.
         * @summary Search Portal Entities
         * @param {SearchIndicesParameters} indices Determines which entity sets to search
         * @param {string} [q] Determines how to filter search results
         * @param {string} [join] Determines which sub-entities to include in search results
         * @param {number} [pageSize] The maximum number of items to include per page. The last page of a collection may include fewer items.
         * @param {number} [pageNumber] Determines which page of the entities to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPortalEntities: function (indices, q, join, pageSize, pageNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'indices' is not null or undefined
                    (0, common_1.assertParamExists)('searchPortalEntities', 'indices', indices);
                    localVarPath = "/api/v2/search/{indices}"
                        .replace("{".concat("indices", "}"), encodeURIComponent(String(indices)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication portalAccessToken required
                    if (q !== undefined) {
                        localVarQueryParameter['q'] = q;
                    }
                    if (join !== undefined) {
                        localVarQueryParameter['join'] = join;
                    }
                    if (pageSize !== undefined) {
                        localVarQueryParameter['page[size]'] = pageSize;
                    }
                    if (pageNumber !== undefined) {
                        localVarQueryParameter['page[number]'] = pageNumber;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.SearchApiAxiosParamCreator = SearchApiAxiosParamCreator;
/**
 * SearchApi - functional programming interface
 * @export
 */
var SearchApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SearchApiAxiosParamCreator)(configuration);
    return {
        /**
         * Returns paginated search results from the specified entities with the given search parameters.
         * @summary Search Portal Entities
         * @param {SearchIndicesParameters} indices Determines which entity sets to search
         * @param {string} [q] Determines how to filter search results
         * @param {string} [join] Determines which sub-entities to include in search results
         * @param {number} [pageSize] The maximum number of items to include per page. The last page of a collection may include fewer items.
         * @param {number} [pageNumber] Determines which page of the entities to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPortalEntities: function (indices, q, join, pageSize, pageNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.searchPortalEntities(indices, q, join, pageSize, pageNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.SearchApiFp = SearchApiFp;
/**
 * SearchApi - factory interface
 * @export
 */
var SearchApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SearchApiFp)(configuration);
    return {
        /**
         * Returns paginated search results from the specified entities with the given search parameters.
         * @summary Search Portal Entities
         * @param {SearchIndicesParameters} indices Determines which entity sets to search
         * @param {string} [q] Determines how to filter search results
         * @param {string} [join] Determines which sub-entities to include in search results
         * @param {number} [pageSize] The maximum number of items to include per page. The last page of a collection may include fewer items.
         * @param {number} [pageNumber] Determines which page of the entities to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPortalEntities: function (indices, q, join, pageSize, pageNumber, options) {
            return localVarFp.searchPortalEntities(indices, q, join, pageSize, pageNumber, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SearchApiFactory = SearchApiFactory;
/**
 * SearchApi - object-oriented interface
 * @export
 * @class SearchApi
 * @extends {BaseAPI}
 */
var SearchApi = /** @class */ (function (_super) {
    __extends(SearchApi, _super);
    function SearchApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns paginated search results from the specified entities with the given search parameters.
     * @summary Search Portal Entities
     * @param {SearchApiSearchPortalEntitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    SearchApi.prototype.searchPortalEntities = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SearchApiFp)(this.configuration).searchPortalEntities(requestParameters.indices, requestParameters.q, requestParameters.join, requestParameters.pageSize, requestParameters.pageNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SearchApi;
}(base_1.BaseAPI));
exports.SearchApi = SearchApi;
/**
 * VersionsApi - axios parameter creator
 * @export
 */
var VersionsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get applications that have a registration for a given product version. Any registration for the version will count, regardless of status (i.e. even if it is pending, rejected, or revoked). Use the `unregistered` query param to return the inverse, only including applicatons that do not have a registration (regardless of status).
         * @summary Get applications by product version
         * @param {string} productId Contains a unique identifier used by the Portal API for this resource.
         * @param {string} productVersionId Contains a unique identifier used by the Portal API for this resource.
         * @param {number} [pageSize] The maximum number of items to include per page. The last page of a collection may include fewer items.
         * @param {number} [pageNumber] Determines which page of the entities to retrieve.
         * @param {string} [filterNameEq] Filter by direct equality comparison of the name property with a supplied value.
         * @param {string} [filterName] Filter by direct equality comparison (short-hand) of the name property with a supplied value.
         * @param {string} [filterNameContains] Filter by contains comparison of the name property with a supplied substring
         * @param {'approved' | 'pending' | 'rejected' | 'revoked'} [filterStatusEq] Filter by direct equality comparison of the status property with a supplied value.
         * @param {'approved' | 'pending' | 'rejected' | 'revoked'} [filterStatus] Filter by direct equality comparison (short-hand) of the status property with a supplied value.
         * @param {string} [filterAuthStrategyIdEq] Filter by the id of the auth strategy supported by the application.
         * @param {string} [filterAuthStrategyId] Filter by the id of the auth strategy supported by the application (short-hand).
         * @param {boolean} [unregistered] Return applications that do **not** have a registration for the product version (regardless of registration status).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationsByProductVersion: function (productId, productVersionId, pageSize, pageNumber, filterNameEq, filterName, filterNameContains, filterStatusEq, filterStatus, filterAuthStrategyIdEq, filterAuthStrategyId, unregistered, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'productId' is not null or undefined
                    (0, common_1.assertParamExists)('getApplicationsByProductVersion', 'productId', productId);
                    // verify required parameter 'productVersionId' is not null or undefined
                    (0, common_1.assertParamExists)('getApplicationsByProductVersion', 'productVersionId', productVersionId);
                    localVarPath = "/api/v2/products/{productId}/versions/{productVersionId}/applications"
                        .replace("{".concat("productId", "}"), encodeURIComponent(String(productId)))
                        .replace("{".concat("productVersionId", "}"), encodeURIComponent(String(productVersionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication portalAccessToken required
                    if (pageSize !== undefined) {
                        localVarQueryParameter['page[size]'] = pageSize;
                    }
                    if (pageNumber !== undefined) {
                        localVarQueryParameter['page[number]'] = pageNumber;
                    }
                    if (filterNameEq !== undefined) {
                        localVarQueryParameter['filter[name][eq]'] = filterNameEq;
                    }
                    if (filterName !== undefined) {
                        localVarQueryParameter['filter[name]'] = filterName;
                    }
                    if (filterNameContains !== undefined) {
                        localVarQueryParameter['filter[name][contains]'] = filterNameContains;
                    }
                    if (filterStatusEq !== undefined) {
                        localVarQueryParameter['filter[status][eq]'] = filterStatusEq;
                    }
                    if (filterStatus !== undefined) {
                        localVarQueryParameter['filter[status]'] = filterStatus;
                    }
                    if (filterAuthStrategyIdEq !== undefined) {
                        localVarQueryParameter['filter[auth_strategy_id][eq]'] = filterAuthStrategyIdEq;
                    }
                    if (filterAuthStrategyId !== undefined) {
                        localVarQueryParameter['filter[auth_strategy_id]'] = filterAuthStrategyId;
                    }
                    if (unregistered !== undefined) {
                        localVarQueryParameter['unregistered'] = unregistered;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Gets the details for an existing product version.
         * @summary Get product version
         * @param {string} productId Contains a unique identifier used by the Portal API for this resource.
         * @param {string} productVersionId Contains a unique identifier used by the Portal API for this resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductVersion: function (productId, productVersionId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'productId' is not null or undefined
                    (0, common_1.assertParamExists)('getProductVersion', 'productId', productId);
                    // verify required parameter 'productVersionId' is not null or undefined
                    (0, common_1.assertParamExists)('getProductVersion', 'productVersionId', productVersionId);
                    localVarPath = "/api/v2/products/{productId}/versions/{productVersionId}"
                        .replace("{".concat("productId", "}"), encodeURIComponent(String(productId)))
                        .replace("{".concat("productVersionId", "}"), encodeURIComponent(String(productVersionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication portalAccessToken required
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Returns the API specification document attached to given product version. Currently only OpenAPI is supported.
         * @summary Get spec for product version
         * @param {string} productId Contains a unique identifier used by the Portal API for this resource.
         * @param {string} productVersionId Contains a unique identifier used by the Portal API for this resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductVersionSpec: function (productId, productVersionId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'productId' is not null or undefined
                    (0, common_1.assertParamExists)('getProductVersionSpec', 'productId', productId);
                    // verify required parameter 'productVersionId' is not null or undefined
                    (0, common_1.assertParamExists)('getProductVersionSpec', 'productVersionId', productVersionId);
                    localVarPath = "/api/v2/products/{productId}/versions/{productVersionId}/spec"
                        .replace("{".concat("productId", "}"), encodeURIComponent(String(productId)))
                        .replace("{".concat("productVersionId", "}"), encodeURIComponent(String(productVersionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication portalAccessToken required
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Returns list of operations used in the API specification document attached to given product version.
         * @summary Get operations in version spec
         * @param {string} productId Contains a unique identifier used by the Portal API for this resource.
         * @param {string} productVersionId Contains a unique identifier used by the Portal API for this resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductVersionSpecOperations: function (productId, productVersionId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'productId' is not null or undefined
                    (0, common_1.assertParamExists)('getProductVersionSpecOperations', 'productId', productId);
                    // verify required parameter 'productVersionId' is not null or undefined
                    (0, common_1.assertParamExists)('getProductVersionSpecOperations', 'productVersionId', productVersionId);
                    localVarPath = "/api/v2/products/{productId}/versions/{productVersionId}/spec/operations"
                        .replace("{".concat("productId", "}"), encodeURIComponent(String(productId)))
                        .replace("{".concat("productVersionId", "}"), encodeURIComponent(String(productVersionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication portalAccessToken required
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Returns paginated list of versions of a given product.
         * @summary Get page of product versions
         * @param {string} productId Contains a unique identifier used by the Portal API for this resource.
         * @param {number} [pageSize] The maximum number of items to include per page. The last page of a collection may include fewer items.
         * @param {number} [pageNumber] Determines which page of the entities to retrieve.
         * @param {string} [filterNameEq] Filter by direct equality comparison of the name property with a supplied value.
         * @param {string} [filterName] Filter by direct equality comparison (short-hand) of the name property with a supplied value.
         * @param {string} [filterNameContains] Filter by contains comparison of the name property with a supplied substring
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProductVersions: function (productId, pageSize, pageNumber, filterNameEq, filterName, filterNameContains, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'productId' is not null or undefined
                    (0, common_1.assertParamExists)('listProductVersions', 'productId', productId);
                    localVarPath = "/api/v2/products/{productId}/versions"
                        .replace("{".concat("productId", "}"), encodeURIComponent(String(productId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication portalAccessToken required
                    if (pageSize !== undefined) {
                        localVarQueryParameter['page[size]'] = pageSize;
                    }
                    if (pageNumber !== undefined) {
                        localVarQueryParameter['page[number]'] = pageNumber;
                    }
                    if (filterNameEq !== undefined) {
                        localVarQueryParameter['filter[name][eq]'] = filterNameEq;
                    }
                    if (filterName !== undefined) {
                        localVarQueryParameter['filter[name]'] = filterName;
                    }
                    if (filterNameContains !== undefined) {
                        localVarQueryParameter['filter[name][contains]'] = filterNameContains;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.VersionsApiAxiosParamCreator = VersionsApiAxiosParamCreator;
/**
 * VersionsApi - functional programming interface
 * @export
 */
var VersionsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.VersionsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get applications that have a registration for a given product version. Any registration for the version will count, regardless of status (i.e. even if it is pending, rejected, or revoked). Use the `unregistered` query param to return the inverse, only including applicatons that do not have a registration (regardless of status).
         * @summary Get applications by product version
         * @param {string} productId Contains a unique identifier used by the Portal API for this resource.
         * @param {string} productVersionId Contains a unique identifier used by the Portal API for this resource.
         * @param {number} [pageSize] The maximum number of items to include per page. The last page of a collection may include fewer items.
         * @param {number} [pageNumber] Determines which page of the entities to retrieve.
         * @param {string} [filterNameEq] Filter by direct equality comparison of the name property with a supplied value.
         * @param {string} [filterName] Filter by direct equality comparison (short-hand) of the name property with a supplied value.
         * @param {string} [filterNameContains] Filter by contains comparison of the name property with a supplied substring
         * @param {'approved' | 'pending' | 'rejected' | 'revoked'} [filterStatusEq] Filter by direct equality comparison of the status property with a supplied value.
         * @param {'approved' | 'pending' | 'rejected' | 'revoked'} [filterStatus] Filter by direct equality comparison (short-hand) of the status property with a supplied value.
         * @param {string} [filterAuthStrategyIdEq] Filter by the id of the auth strategy supported by the application.
         * @param {string} [filterAuthStrategyId] Filter by the id of the auth strategy supported by the application (short-hand).
         * @param {boolean} [unregistered] Return applications that do **not** have a registration for the product version (regardless of registration status).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationsByProductVersion: function (productId, productVersionId, pageSize, pageNumber, filterNameEq, filterName, filterNameContains, filterStatusEq, filterStatus, filterAuthStrategyIdEq, filterAuthStrategyId, unregistered, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getApplicationsByProductVersion(productId, productVersionId, pageSize, pageNumber, filterNameEq, filterName, filterNameContains, filterStatusEq, filterStatus, filterAuthStrategyIdEq, filterAuthStrategyId, unregistered, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Gets the details for an existing product version.
         * @summary Get product version
         * @param {string} productId Contains a unique identifier used by the Portal API for this resource.
         * @param {string} productVersionId Contains a unique identifier used by the Portal API for this resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductVersion: function (productId, productVersionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProductVersion(productId, productVersionId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns the API specification document attached to given product version. Currently only OpenAPI is supported.
         * @summary Get spec for product version
         * @param {string} productId Contains a unique identifier used by the Portal API for this resource.
         * @param {string} productVersionId Contains a unique identifier used by the Portal API for this resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductVersionSpec: function (productId, productVersionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProductVersionSpec(productId, productVersionId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns list of operations used in the API specification document attached to given product version.
         * @summary Get operations in version spec
         * @param {string} productId Contains a unique identifier used by the Portal API for this resource.
         * @param {string} productVersionId Contains a unique identifier used by the Portal API for this resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductVersionSpecOperations: function (productId, productVersionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProductVersionSpecOperations(productId, productVersionId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns paginated list of versions of a given product.
         * @summary Get page of product versions
         * @param {string} productId Contains a unique identifier used by the Portal API for this resource.
         * @param {number} [pageSize] The maximum number of items to include per page. The last page of a collection may include fewer items.
         * @param {number} [pageNumber] Determines which page of the entities to retrieve.
         * @param {string} [filterNameEq] Filter by direct equality comparison of the name property with a supplied value.
         * @param {string} [filterName] Filter by direct equality comparison (short-hand) of the name property with a supplied value.
         * @param {string} [filterNameContains] Filter by contains comparison of the name property with a supplied substring
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProductVersions: function (productId, pageSize, pageNumber, filterNameEq, filterName, filterNameContains, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listProductVersions(productId, pageSize, pageNumber, filterNameEq, filterName, filterNameContains, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.VersionsApiFp = VersionsApiFp;
/**
 * VersionsApi - factory interface
 * @export
 */
var VersionsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.VersionsApiFp)(configuration);
    return {
        /**
         * Get applications that have a registration for a given product version. Any registration for the version will count, regardless of status (i.e. even if it is pending, rejected, or revoked). Use the `unregistered` query param to return the inverse, only including applicatons that do not have a registration (regardless of status).
         * @summary Get applications by product version
         * @param {string} productId Contains a unique identifier used by the Portal API for this resource.
         * @param {string} productVersionId Contains a unique identifier used by the Portal API for this resource.
         * @param {number} [pageSize] The maximum number of items to include per page. The last page of a collection may include fewer items.
         * @param {number} [pageNumber] Determines which page of the entities to retrieve.
         * @param {string} [filterNameEq] Filter by direct equality comparison of the name property with a supplied value.
         * @param {string} [filterName] Filter by direct equality comparison (short-hand) of the name property with a supplied value.
         * @param {string} [filterNameContains] Filter by contains comparison of the name property with a supplied substring
         * @param {'approved' | 'pending' | 'rejected' | 'revoked'} [filterStatusEq] Filter by direct equality comparison of the status property with a supplied value.
         * @param {'approved' | 'pending' | 'rejected' | 'revoked'} [filterStatus] Filter by direct equality comparison (short-hand) of the status property with a supplied value.
         * @param {string} [filterAuthStrategyIdEq] Filter by the id of the auth strategy supported by the application.
         * @param {string} [filterAuthStrategyId] Filter by the id of the auth strategy supported by the application (short-hand).
         * @param {boolean} [unregistered] Return applications that do **not** have a registration for the product version (regardless of registration status).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationsByProductVersion: function (productId, productVersionId, pageSize, pageNumber, filterNameEq, filterName, filterNameContains, filterStatusEq, filterStatus, filterAuthStrategyIdEq, filterAuthStrategyId, unregistered, options) {
            return localVarFp.getApplicationsByProductVersion(productId, productVersionId, pageSize, pageNumber, filterNameEq, filterName, filterNameContains, filterStatusEq, filterStatus, filterAuthStrategyIdEq, filterAuthStrategyId, unregistered, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Gets the details for an existing product version.
         * @summary Get product version
         * @param {string} productId Contains a unique identifier used by the Portal API for this resource.
         * @param {string} productVersionId Contains a unique identifier used by the Portal API for this resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductVersion: function (productId, productVersionId, options) {
            return localVarFp.getProductVersion(productId, productVersionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns the API specification document attached to given product version. Currently only OpenAPI is supported.
         * @summary Get spec for product version
         * @param {string} productId Contains a unique identifier used by the Portal API for this resource.
         * @param {string} productVersionId Contains a unique identifier used by the Portal API for this resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductVersionSpec: function (productId, productVersionId, options) {
            return localVarFp.getProductVersionSpec(productId, productVersionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns list of operations used in the API specification document attached to given product version.
         * @summary Get operations in version spec
         * @param {string} productId Contains a unique identifier used by the Portal API for this resource.
         * @param {string} productVersionId Contains a unique identifier used by the Portal API for this resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductVersionSpecOperations: function (productId, productVersionId, options) {
            return localVarFp.getProductVersionSpecOperations(productId, productVersionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns paginated list of versions of a given product.
         * @summary Get page of product versions
         * @param {string} productId Contains a unique identifier used by the Portal API for this resource.
         * @param {number} [pageSize] The maximum number of items to include per page. The last page of a collection may include fewer items.
         * @param {number} [pageNumber] Determines which page of the entities to retrieve.
         * @param {string} [filterNameEq] Filter by direct equality comparison of the name property with a supplied value.
         * @param {string} [filterName] Filter by direct equality comparison (short-hand) of the name property with a supplied value.
         * @param {string} [filterNameContains] Filter by contains comparison of the name property with a supplied substring
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProductVersions: function (productId, pageSize, pageNumber, filterNameEq, filterName, filterNameContains, options) {
            return localVarFp.listProductVersions(productId, pageSize, pageNumber, filterNameEq, filterName, filterNameContains, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.VersionsApiFactory = VersionsApiFactory;
/**
 * VersionsApi - object-oriented interface
 * @export
 * @class VersionsApi
 * @extends {BaseAPI}
 */
var VersionsApi = /** @class */ (function (_super) {
    __extends(VersionsApi, _super);
    function VersionsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get applications that have a registration for a given product version. Any registration for the version will count, regardless of status (i.e. even if it is pending, rejected, or revoked). Use the `unregistered` query param to return the inverse, only including applicatons that do not have a registration (regardless of status).
     * @summary Get applications by product version
     * @param {VersionsApiGetApplicationsByProductVersionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VersionsApi
     */
    VersionsApi.prototype.getApplicationsByProductVersion = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VersionsApiFp)(this.configuration).getApplicationsByProductVersion(requestParameters.productId, requestParameters.productVersionId, requestParameters.pageSize, requestParameters.pageNumber, requestParameters.filterNameEq, requestParameters.filterName, requestParameters.filterNameContains, requestParameters.filterStatusEq, requestParameters.filterStatus, requestParameters.filterAuthStrategyIdEq, requestParameters.filterAuthStrategyId, requestParameters.unregistered, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Gets the details for an existing product version.
     * @summary Get product version
     * @param {VersionsApiGetProductVersionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VersionsApi
     */
    VersionsApi.prototype.getProductVersion = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VersionsApiFp)(this.configuration).getProductVersion(requestParameters.productId, requestParameters.productVersionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns the API specification document attached to given product version. Currently only OpenAPI is supported.
     * @summary Get spec for product version
     * @param {VersionsApiGetProductVersionSpecRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VersionsApi
     */
    VersionsApi.prototype.getProductVersionSpec = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VersionsApiFp)(this.configuration).getProductVersionSpec(requestParameters.productId, requestParameters.productVersionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns list of operations used in the API specification document attached to given product version.
     * @summary Get operations in version spec
     * @param {VersionsApiGetProductVersionSpecOperationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VersionsApi
     */
    VersionsApi.prototype.getProductVersionSpecOperations = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VersionsApiFp)(this.configuration).getProductVersionSpecOperations(requestParameters.productId, requestParameters.productVersionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns paginated list of versions of a given product.
     * @summary Get page of product versions
     * @param {VersionsApiListProductVersionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VersionsApi
     */
    VersionsApi.prototype.listProductVersions = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VersionsApiFp)(this.configuration).listProductVersions(requestParameters.productId, requestParameters.pageSize, requestParameters.pageNumber, requestParameters.filterNameEq, requestParameters.filterName, requestParameters.filterNameContains, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return VersionsApi;
}(base_1.BaseAPI));
exports.VersionsApi = VersionsApi;
//# sourceMappingURL=api.js.map